<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems" class="breadcrumb mx-16">
    </v-breadcrumbs>
    <!-- <v-card style="border-radius: 15px"> -->
    <v-row dense class="mx-16 justify-center v-step-0">
      <v-col cols="12" sm="12" md="3" lg="3" class="mt-2">
        <v-combobox v-model="gene_select" dense clearable clear-icon="mdi-close-circle" :loading="gene_loading"
          :items="gene_items" :search-input.sync="gene_search" outlined rounded label="Gene Name"
          :messages="gene_message" :error-messages="gene_error_message">
        </v-combobox>
      </v-col>
      <v-col cols="12" sm="12" md="2" lg="2" class="mt-2">
        <v-select v-model="as_select" dense clearable clear-icon="mdi-close-circle" :items="as_items" outlined rounded
          label="AS Type" :messages="as_message" :error-messages="as_error_message">
        </v-select>
      </v-col>
      <v-col cols="12" sm="12" md="4" lg="4" class="mt-2">
        <v-combobox v-model="coordinate_select" dense clearable clear-icon="mdi-close-circle" :items="coordinate_items"
          outlined rounded label="Event Coordinates" :messages="coordinate_message"
          :error-messages="coordinate_error_message">
        </v-combobox>
      </v-col>
      <v-col cols="12" sm="12" md="1" xl="1" class="mt-2">
        <v-btn @click="submit()" color="info" class="ml-3 font-weight-bold" rounded outlined v-preventReClick
          :disabled="isDisableGo">Go !</v-btn>
      </v-col>
    </v-row>

    <v-row dense class="mx-16 justify-center">
      <!-- Show Transcript Selectionc (Splice-In / Splice-Out) -->
      <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-center mt-n4 mb-n4 v-step-3">
        <v-radio-group v-model="view_select" row dense>
          <v-radio label="All Transcripts" color="primary" value="all" @click="showAllTranscript()"></v-radio>
          <v-radio label="Protein-coding Transcripts" color="info" value="protein_coding"
            @click="showProteinCodingTranscript()"></v-radio>
          <v-radio label="Splice-in Transcripts" color="success" value="splice_in" :disabled="isDisableSpliceInOut"
            @click="showSpliceInTranscript()"></v-radio>
          <v-radio label="Splice-out Transcripts" color="warning" value="splice_out" :disabled="isDisableSpliceInOut"
            @click="showSpliceOutTranscript()"></v-radio>
        </v-radio-group>
      </v-col>

      <!-- Visualization - Transcript -->
      <v-col sm="6" md="6" lg="6" cols="12" class="v-step-1">
        <div id="allIsoform">
          <!-- <div>
            <v-btn color="primary"
                   @click="downloadTranscript">Download</v-btn>
          </div> -->
          <svg></svg>
          <div class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="zoomin mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
                  <v-icon small>mdi-plus-circle-outline</v-icon>
                  <!-- <span class="font-weight-bold">Zoom in</span> -->
                </v-btn>
              </template>
              <span>zoom in</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="zoomout mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
                  <v-icon small>mdi-minus-circle-outline</v-icon>
                  <!-- <span class="font-weight-bold">Zoom out</span> -->
                </v-btn>
              </template>
              <span>zoom out</span>
            </v-tooltip>

            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="eventfocus mr-3"
                       color="info"
                       x-small
                       fab
                       v-bind="attrs"
                       v-on="on"
                       v-preventReClick
                       :disabled="isDisableEventBtn">
                  <v-icon small>mdi-image-filter-center-focus-strong</v-icon>
                </v-btn>
              </template>
              <span>focus on AS event</span>
            </v-tooltip> -->

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="reset mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
                  <v-icon small>mdi-reply</v-icon>
                  <!-- <span class="font-weight-bold">Reset</span> -->
                </v-btn>
              </template>
              <span>reset</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="help mr-3" color="info" x-small fab v-bind="attrs" v-on="on" style="cursor: auto">
                  <v-icon>mdi-help</v-icon>
                </v-btn>
              </template>
              <span class="red--text font-weight-bold">Tips:</span><br />
              <span>Double-click: zoom in</span><br />
              <span>Single-click: reset</span><br />
              <span>Press and hold down the left mouse: drag</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="download mr-3" color="info" @click="downloadTranscript" x-small fab v-bind="attrs"
                  v-on="on">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>download</span><br />
            </v-tooltip>
          </div>
        </div>
      </v-col>

      <!-- Visualization - Protein -->
      <v-col sm="6" md="6" lg="6" cols="12" class="v-step-2">
        <div id="allProtein">
          <svg></svg>
          <div class="d-flex justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="zoomin mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
                  <v-icon small>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>zoom in</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="zoomout mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
                  <v-icon small>mdi-minus-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>zoom out</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="reset mr-3" color="info" x-small fab v-bind="attrs" v-on="on">
                  <v-icon small>mdi-reply</v-icon>
                </v-btn>
              </template>
              <span>reset</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="reset mr-3" color="info" x-small fab v-bind="attrs" v-on="on" style="cursor: auto">
                  <v-icon>mdi-help</v-icon>
                </v-btn>
              </template>
              <span class="red--text font-weight-bold">Tips:</span><br />
              <span>Double-click: zoom in</span><br />
              <span>Single-click: reset</span><br />
              <span>Press and hold down the left mouse: drag</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="download mr-3" color="info" @click="downloadProtein" x-small fab v-bind="attrs" v-on="on">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>download</span><br />
            </v-tooltip>
          </div>
        </div>
      </v-col>

      <!-- All AS Models of Gene -->
      <v-col cols="12" sm="12" lg="12" md="12" v-show="$route.query.genename" class="v-step-4">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2" style="padding: 10px">
            Alternative Splicing Models of Gene (<span class="info--text">{{
              $route.query.genename
            }}</span>)
            <span class="mx-3" v-show="isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small @click="refreshASModel" v-on="on" v-bind="attrs" outlined color="info">
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </template>
                <span>Click to remove the selected AS Model.</span>
              </v-tooltip>
            </span>
            <span class="mx-3" v-show="!isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-on="on" v-bind="attrs" outlined style="cursor: auto">
                    <v-icon>mdi-filter-off</v-icon>
                  </v-btn>
                </template>
                <span>You can select one of the following AS Models by clicking the
                  row or entering the event coordinates.</span>
              </v-tooltip>
            </span>
            <span class="mr-2" v-show="isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-on="on" v-bind="attrs" outlined style="cursor: auto">
                    <v-icon>mdi-help</v-icon>
                  </v-btn>
                </template>
                <span>The blue background represents the same AS Model.</span>
              </v-tooltip>
            </span>
          </v-card-title>
          <v-data-table dense class="data-table-style" :headers="headers_as_model" :items="as_model_items" fixed-header
            v-model="selected_row" :loading="loading_as_model" loading-text="Loading... Please wait"
            no-data-text="There is no AS Models." hide-default-footer :page.sync="currentPage_as_model"
            :items-per-page="pageSize_as_model">
            <template v-slot:item="{ item }">
              <tr :class="selected_row && selected_row.indexOf(item.as_model_id) > -1
                ? 'blue lighten-5'
                : ''
                " @click="rowClicked(item)" style="cursor: pointer">
                <td>{{ item.index }}</td>
                <td>{{ item.as_type }}</td>
                <td>{{ item.as_model_id }}</td>
                <td>
                  <span v-for="(flag, index) in item.flag" :key="index">
                    <v-chip outlined small :color="flag == 'CASE' ? 'info' : 'success'">
                      {{ flag }}
                    </v-chip>
                  </span>
                </td>
              </tr>
            </template>
            <!-- header.flag slot -->
            <template v-slot:[`header.flag`]="{ header }">
              {{ header.text }}
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                </template>
                <span><span class="font-weight-bold info--text">CASE</span>: Cancer
                  Associated Splicing Events<br />
                  <span class="font-weight-bold success--text">CPSE</span>:
                  Computationally Putative Splicing Events</span>
              </v-tooltip>
            </template>
          </v-data-table>
          <div class="d-flex justify-center mt-1" style="max-height: 50px">
            <span class="text-body-1 mt-3">Items per page</span>
            <v-select v-model="pageSize_as_model" dense outlined :items="pageSizes_as_model"
              class="pagesize-select mt-1 mx-2" @input="handlePageSizeChange_as_model(pageSize_as_model)">
            </v-select>
            <span class="text-body-1 mt-3 mx-2">Total
              <span class="font-weight-bold info--text">{{
                totalItems_as_model
              }}</span>
              items
            </span>
            <v-pagination v-model="currentPage_as_model" color="info" :length="totalPages_as_model" :total-visible="5"
              class="mx-1" @input="handlePageChange_as_model" prev-icon="mdi-menu-left" next-icon="mdi-menu-right">
            </v-pagination>
            <span class="text-body-1 mt-2 mx-2">Page</span>
            <v-text-field outlined dense v-model="whichPage_as_model" type="number" class="jump-select" append-icon="">
            </v-text-field>
            <v-btn color="" depressed outlined class="mx-2" @click="jumpPage_as_model()">Jump</v-btn>
          </div>
        </v-card>
      </v-col>

      <!-- Splicing Knowledge -->
      <v-col cols="12" sm="12" lg="12" md="12" v-show="$route.query.genename" class="v-step-5">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2" style="padding: 10px">
            Cancer Associated Splicing Events (CASE) of Gene (<span class="info--text">{{ $route.query.genename
              }}</span>)
            <span class="mx-3" v-show="isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small @click="refreshASModel" v-on="on" v-bind="attrs" outlined color="info">
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </template>
                <span>Click to remove the selected AS Model.</span>
              </v-tooltip>
            </span>
            <span class="mx-3" v-show="!isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-on="on" v-bind="attrs" outlined style="cursor: auto">
                    <v-icon>mdi-filter-off</v-icon>
                  </v-btn>
                </template>
                <span>You can select one of the following AS Models by clicking the
                  row or entering the event coordinates.</span>
              </v-tooltip>
            </span>
            <span class="mr-2" v-show="isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-on="on" v-bind="attrs" outlined style="cursor: auto">
                    <v-icon>mdi-help</v-icon>
                  </v-btn>
                </template>
                <span>The blue background represents the same AS Model.</span>
              </v-tooltip>
            </span>
          </v-card-title>
          <v-col cols="12">
            <v-expansion-panels class="data-table-style">
              <v-expansion-panel>
                <v-expansion-panel-header expand-icon="mdi-menu-down" style="padding: 10px 25px">
                  <div class="d-flex font-weight-bold">
                    <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                    <v-chip outlined small color="success" class="ml-2" @click="showAll()">
                      Select All
                    </v-chip>
                    <v-chip outlined small color="error" class="ml-2" @click="showDefault()">
                      Select Default
                    </v-chip>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="v-item-group">
                    <v-checkbox v-for="(header, index) in headers_knowledge" :key="index" :label="header.text"
                      :value="header.text" v-model="selectedHeader" dense class="mx-1"></v-checkbox>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-data-table dense class="data-table-style mt-1" :headers="selectedHeaders" :items="splice_knowledge"
              fixed-header v-model="selected_row" item-key="_id" :search="search_knowledge" :loading="loading_knowledge"
              loading-text="Loading... Please wait" no-data-text="There is no CASE." hide-default-footer
              :page.sync="currentPage" :items-per-page="pageSize">
              <template v-slot:item="{ item }">
                <tr :class="selected_row && selected_row.indexOf(item.as_model_id) > -1
                  ? 'blue lighten-5'
                  : ''
                  " @click="rowClicked(item)" style="cursor: pointer">
                  <td v-show="selectedHeader.indexOf('Event ID') > -1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{
                          item.event_id
                        }}</span>
                      </template>
                      <span><span class="error--text font-weight-bold">Event ID:
                        </span>
                        Gene _ Chromsome _ Strand _ AS Type _ Event
                        Coordinates</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('AS Model ID') > -1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{
                          item.as_model_id
                        }}</span>
                      </template>
                      <span><span class="error--text font-weight-bold">AS Model ID: </span>Gene _ Chromsome _ Strand _
                        AS Type _
                        AS Model
                        Coordinates</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('Gene Name') > -1">
                    <a @click="goToGeneSearchResult(item.gene_name)">
                      <span class="font-weight-bold">{{ item.gene_name }}</span>
                    </a>
                  </td>
                  <td v-show="selectedHeader.indexOf('Ensembl ID') > -1">
                    <span>{{ item.ensembl_id }}</span>
                  </td>
                  <td v-show="selectedHeader.indexOf('Chromsome') > -1">
                    <span>{{ item.chr }}</span>
                  </td>
                  <td v-show="selectedHeader.indexOf('Strand') > -1">
                    <span>{{ item.strand }}</span>
                  </td>
                  <td v-show="selectedHeader.indexOf('Cancer Type') > -1">
                    <span v-if="!item.cancer_name.includes(',')">{{
                      item.cancer_name
                    }}</span>
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{ item.cancer_name.split(", ")[0] }} ...</span>
                      </template>
                      <span>{{ item.cancer_name }}</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('Canonical Transcript') > -1">
                    {{ item.ct_ensembl_id }}
                  </td>
                  <td v-show="selectedHeader.indexOf('Splicing Variant') > -1">
                    {{ item.sv_ensembl_id }}
                  </td>
                  <td v-show="selectedHeader.indexOf('AS Type') > -1">
                    {{ item.as_type }}
                  </td>
                  <td v-show="selectedHeader.indexOf('Event Coordinates') > -1">
                    {{ item.event_coordinates }}
                  </td>
                  <td v-show="selectedHeader.indexOf('Alt Coordinates') > -1">
                    {{ item.alt_coordinates }}
                  </td>
                  <td v-show="selectedHeader.indexOf('ORF') > -1">
                    {{ item.orf_annotation }}
                  </td>
                  <td v-show="selectedHeader.indexOf('Method') > -1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-icon v-if="item.methods !== ('' || '-' || 'NA')"
                            color="success">mdi-check-circle-outline</v-icon>
                          <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
                        </span>
                      </template>
                      <span>{{ item.methods }}</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('Mechanism') > -1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-icon v-if="
                            item.regulatory_mechanism !== ('' || '-' || 'NA')
                          " color="success">mdi-check-circle-outline</v-icon>
                          <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
                        </span>
                      </template>
                      <span>{{ item.regulatory_mechanism }}</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('Function') > -1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-icon v-if="
                            item.biological_function !== ('' || '-' || 'NA')
                          " color="success">mdi-check-circle-outline</v-icon>
                          <v-icon v-else color="error">mdi-close-circle-outline</v-icon>
                        </span>
                      </template>
                      <span>{{ item.biological_function }}</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('Primary Site') > -1">
                    {{ item.primary_site }}
                  </td>
                  <td v-show="selectedHeader.indexOf('Year') > -1">
                    {{ item.year }}
                  </td>
                  <td v-show="selectedHeader.indexOf('PubMed') > -1">
                    <a :href="pubmedLink + item.pubmed_id" target="_blank">{{
                      item.pubmed_id
                    }}</a>
                  </td>
                  <td v-show="selectedHeader.indexOf('Journal') > -1">
                    {{ item.journal }}
                  </td>
                  <td v-show="selectedHeader.indexOf('Title') > -1">
                    <span v-if="item.title.length <= 100">{{
                      item.title
                    }}</span>
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">{{
                          item.title.slice(0, 100) + "..."
                        }}</span>
                      </template>
                      <span>{{ item.title }}</span>
                    </v-tooltip>
                  </td>
                  <td v-show="selectedHeader.indexOf('Network') > -1">
                    <v-btn @click="goToRegulationNetwork(item.gene_name)" color="info" icon>
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-icon-copy"></use>
                      </svg>
                    </v-btn>
                  </td>
                  <td v-show="selectedHeader.indexOf('Explorer') > -1">
                    <v-btn @click="
                      goToRegulationExplorer(
                        item.gene_name,
                        'TCGA',
                        item.tcga_project_id,
                        item.event_id
                      )
                      " color="grey" icon :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex'
                        ">
                      <svg class="icon" aria-hidden="true" v-if="
                        item.has_oncoprint == 'no' ||
                        item.as_type == 'Complex'
                      ">
                        <use xlink:href="#icon-GridView-diable"></use>
                      </svg>
                      <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#icon-GridView-oncoprint"></use>
                      </svg>
                    </v-btn>
                  </td>
                  <td v-show="selectedHeader.indexOf('Survival') > -1">
                    <v-btn @click="
                      goToSurvival(
                        item.gene_name,
                        'TCGA',
                        item.tcga_project_id,
                        item.event_id
                      )
                      " color="info" icon :disabled="item.has_oncoprint == 'no' ||
                        item.as_type == 'Complex' ||
                        !survival_project_items.includes(item.tcga_project_id)
                        ">
                      <svg class="icon" aria-hidden="true" v-if="
                        item.has_oncoprint == 'no' ||
                        item.as_type == 'Complex' ||
                        !survival_project_items.includes(item.tcga_project_id)
                      ">
                        <use xlink:href="#icon-linechart-diable"></use>
                      </svg>
                      <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#icon-linechart"></use>
                      </svg>
                    </v-btn>
                  </td>
                  <td v-show="selectedHeader.indexOf('Staging') > -1">
                    <v-btn @click="
                      goToStaging(
                        item.gene_name,
                        'TCGA',
                        item.tcga_project_id,
                        item.event_id
                      )
                      " color="info" icon :disabled="item.has_oncoprint == 'no' ||
                        item.as_type == 'Complex' ||
                        !stage_project_items.includes(item.tcga_project_id)
                        ">
                      <svg class="icon" aria-hidden="true" v-if="
                        item.has_oncoprint == 'no' ||
                        item.as_type == 'Complex' ||
                        !stage_project_items.includes(item.tcga_project_id)
                      ">
                        <use xlink:href="#icon-xiangxiantu-disable"></use>
                      </svg>
                      <svg class="icon" aria-hidden="true" v-else>
                        <use xlink:href="#icon-xiangxiantu"></use>
                      </svg>
                    </v-btn>
                  </td>
                  <td v-show="selectedHeader.indexOf('Details') > -1">
                    <v-btn @click="
                      goToDetails(
                        item.event_id,
                        item.cancer_name,
                        item.pubmed_id
                      )
                      " color="info" icon>
                      <v-icon>mdi-chevron-right-circle</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>

              <!-- header.methods slot -->
              <template v-slot:[`header.methods`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>existent:
                    <v-icon small color="success">mdi-check-circle-outline</v-icon><br />non-existent:
                    <v-icon small color="error">mdi-close-circle-outline</v-icon></span>
                </v-tooltip>
              </template>

              <!-- header.regulatory_mechanism slot -->
              <template v-slot:[`header.regulatory_mechanism`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>existent:
                    <v-icon small color="success">mdi-check-circle-outline</v-icon><br />non-existent:
                    <v-icon small color="error">mdi-close-circle-outline</v-icon></span>
                </v-tooltip>
              </template>

              <!-- header.biological_function slot -->
              <template v-slot:[`header.biological_function`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>existent:
                    <v-icon small color="success">mdi-check-circle-outline</v-icon><br />non-existent:
                    <v-icon small color="error">mdi-close-circle-outline</v-icon></span>
                </v-tooltip>
              </template>

              <!-- header.regulatory_network slot -->
              <template v-slot:[`header.regulatory_network`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Splicing Regulatory Network</span>
                </v-tooltip>
              </template>

              <!-- header.regulatory_explorer slot -->
              <template v-slot:[`header.regulatory_explorer`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Splicing Regulatory Explorer</span>
                </v-tooltip>
              </template>

              <!-- header.survival slot -->
              <template v-slot:[`header.survival`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Survival Analysis</span>
                </v-tooltip>
              </template>

              <!-- header.staging slot -->
              <template v-slot:[`header.staging`]="{ header }">
                {{ header.text }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                  </template>
                  <span>Cancer Staging Analysis</span>
                </v-tooltip>
              </template>

              <!-- item.visualization slot -->
              <!-- <template v-slot:[`item.visualization`]="{item}">
                <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
                       color="info"
                       icon
                       :disabled="['Complex', 'AF', 'AL'].includes(item.as_type)">
                  <v-icon>mdi-tune</v-icon>
                </v-btn>
              </template> -->
            </v-data-table>
            <div class="d-flex justify-center mt-1" style="max-height: 50px">
              <span class="text-body-1 mt-3">Items per page</span>
              <v-select v-model="pageSize" dense outlined :items="pageSizes" class="pagesize-select mt-1 mx-2"
                @input="handlePageSizeChange(pageSize)">
              </v-select>
              <span class="text-body-1 mt-3 mx-2">Total
                <span class="font-weight-bold info--text">{{
                  totalItems
                }}</span>
                items
              </span>
              <v-pagination v-model="currentPage" color="info" :length="totalPages" :total-visible="5" class="mx-1"
                @input="handlePageChange" prev-icon="mdi-menu-left" next-icon="mdi-menu-right">
              </v-pagination>
              <span class="text-body-1 mt-2 mx-2">Page</span>
              <v-text-field outlined dense v-model="whichPage" type="number" class="jump-select" append-icon="">
              </v-text-field>
              <v-btn color="" depressed outlined class="mx-2" @click="jumpPage()">Jump</v-btn>
            </div>
          </v-col>
        </v-card>
      </v-col>

      <!-- Splicing Datasets -->
      <v-col cols="12" sm="12" lg="12" md="12" v-show="$route.query.genename" class="v-step-6">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2" style="padding: 10px">
            Computationally Putative Splicing Events (CPSE) of Gene (<span class="info--text">{{ $route.query.genename
              }}</span>)
            <span class="mx-3" v-show="isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small outlined @click="refreshASModel" v-on="on" v-bind="attrs" color="info">
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </template>
                <span>Click to remove the selected AS Model.</span>
              </v-tooltip>
            </span>
            <span class="mx-3" v-show="!isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-on="on" v-bind="attrs" outlined style="cursor: auto">
                    <v-icon>mdi-filter-off</v-icon>
                  </v-btn>
                </template>
                <span>You can select one of the following AS Models by clicking the
                  row or entering the event coordinates.</span>
              </v-tooltip>
            </span>
            <span class="mr-2" v-show="isShowFilterASModel">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon x-small v-on="on" v-bind="attrs" outlined style="cursor: auto">
                    <v-icon>mdi-help</v-icon>
                  </v-btn>
                </template>
                <span>The blue background represents the same AS Model.</span>
              </v-tooltip>
            </span>
          </v-card-title>
          <datasets-result-by-gene-clickable :gene-name="gene_select" :as-type="as_select" :selected-row="selected_row"
            @row-click="rowClicked($event)"></datasets-result-by-gene-clickable>
        </v-card>
      </v-col>

      <!-- Transcript Information -->
      <v-col cols="12" sm="12" lg="12" md="12" v-show="transcript.length > 0" v-for="item in gencodeGenePattern"
        :key="item._id" class="v-step-7">
        <v-card>
          <v-card-title class="font-weight-bold grey lighten-2">
            {{ getCurrentShowTranscriptName }} Information of Gene (<span class="info--text">{{ item.gene_name
              }}</span>)
          </v-card-title>
          <v-simple-table dense fixed-header :height="computeHeight(item.transcript)">
            <template v-slot:default>
              <thead class="">
                <tr>
                  <th class="text-left">Transcript Symbol</th>
                  <th class="text-left">Transcript ID</th>
                  <th class="text-left">RefSeq Transcript ID</th>
                  <th class="text-left">Transcript Type</th>
                  <th class="text-left">Transcript Status</th>
                  <th class="text-left">Transcript Support Level</th>
                  <th class="text-left">Protein ID</th>
                  <th class="text-left">RefSeq Protein ID</th>
                  <th class="text-left">UniProt ID</th>
                  <th class="text-left">AlphaFold</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tx in item.transcript" :key="tx.transcript_id">
                  <td>{{ tx.transcript_name }}</td>
                  <td>
                    <a :href="ensemblLink + tx.transcript_id" target="_blank">{{
                      tx.transcript_id && tx.transcript_id.split(".")[0]
                    }}</a>
                  </td>
                  <td>
                    <span><a :href="refseqLink + tx.refseq_nm" target="_blank">{{ tx.refseq_nm }}
                      </a></span>
                  </td>
                  <td>{{ tx.transcript_type }}</td>
                  <td>{{ tx.transcript_status }}</td>
                  <td>{{ tx.transcript_level }}</td>
                  <td>
                    <a :href="ensemblLink + tx.protein_id" target="_blank">{{
                      tx.protein_id && tx.protein_id.split(".")[0]
                    }}</a>
                  </td>
                  <td>
                    <span><a :href="refseqLink + tx.refseq_np" target="_blank">{{ tx.refseq_np }}
                      </a></span>
                  </td>
                  <td>
                    <span><a :href="uniprotLink + tx.uniprot_id" target="_blank">{{ tx.uniprot_id }}
                      </a></span>
                  </td>
                  <td>
                    <span><a :href="alphafoldLink + tx.uniprot_id" target="_blank">{{ tx.uniprot_id }}
                      </a></span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>

      <!-- event-pancancer-psi-distribution -->
      <v-col cols="12" sm="12" lg="12" md="12" v-show="isShowPsiBoxPlot" class="v-step-8">
        <v-card>
          <v-card-title class="justify-start grey lighten-2" style="padding: 8px">
            <span class="font-weight-bold">PSI Distribution of AS Event in TCGA Pan-Cancer
              <span class="mx-2">
                <v-dialog v-model="dialog" :retain-focus="false">
                  <template v-slot:activator="{}">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="" icon small @click.stop="dialog = true" v-bind="attrs" v-on="on">
                          <v-icon>mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Click here to get the extension of tumor
                        abbreviations.</span>
                    </v-tooltip>
                  </template>
                  <v-card style="left: 25%; width: 50%">
                    <v-card-title class="font-weight-bold grey lighten-2" style="padding: 0px 0px 0px 20px">
                      TCGA Project ID - Project Name
                      <v-spacer></v-spacer>
                      <v-btn icon large @click="dialog = false">
                        <v-icon>mdi-close-circle</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-simple-table dense fixed-header height="600px">
                      <template v-slot:default>
                        <thead class="font-weight-bold">
                          <tr>
                            <th class="text-left" style="width: 30%">
                              Project ID
                            </th>
                            <th class="text-left" style="width: 70%">
                              Project Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>TCGA-ACC</td>
                            <td>Adrenocortical Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-BLCA</td>
                            <td>Bladder Urothelial Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-BRCA</td>
                            <td>Breast Invasive Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-CESC</td>
                            <td>
                              Cervical Squamous Cell Carcinoma and Endocervical
                              Adenocarcinoma
                            </td>
                          </tr>
                          <tr>
                            <td>TCGA-CHOL</td>
                            <td>Cholangiocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-COAD</td>
                            <td>Colon Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-DLBC</td>
                            <td>
                              Lymphoid Neoplasm Diffuse Large B-cell Lymphoma
                            </td>
                          </tr>
                          <tr>
                            <td>TCGA-ESCA</td>
                            <td>Esophageal Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-GBM</td>
                            <td>Glioblastoma Multiforme</td>
                          </tr>
                          <tr>
                            <td>TCGA-HNSC</td>
                            <td>Head and Neck Squamous Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-KICH</td>
                            <td>Kidney Chromophobe</td>
                          </tr>
                          <tr>
                            <td>TCGA-KIRC</td>
                            <td>Kidney Renal Clear Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-KIRP</td>
                            <td>Kidney Renal Papillary Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LGG</td>
                            <td>Brain Lower Grade Glioma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LIHC</td>
                            <td>Liver Hepatocellular Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LUAD</td>
                            <td>Lung Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LUSC</td>
                            <td>Lung Squamous Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-MESO</td>
                            <td>Mesothelioma</td>
                          </tr>
                          <tr>
                            <td>TCGA-OV</td>
                            <td>Ovarian Serous Cystadenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-PAAD</td>
                            <td>Pancreatic Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-PCPG</td>
                            <td>Pheochromocytoma and Paraganglioma</td>
                          </tr>
                          <tr>
                            <td>TCGA-PRAD</td>
                            <td>Prostate Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-READ</td>
                            <td>Rectum Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-SARC</td>
                            <td>Sarcoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-SKCM</td>
                            <td>Skin Cutaneous Melanoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-STAD</td>
                            <td>Stomach Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-TGCT</td>
                            <td>Testicular Germ Cell Tumors</td>
                          </tr>
                          <tr>
                            <td>TCGA-THCA</td>
                            <td>Thyroid Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-THYM</td>
                            <td>Thymoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-UCEC</td>
                            <td>Uterine Corpus Endometrial Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-UCS</td>
                            <td>Uterine Carcinosarcoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-UVM</td>
                            <td>Uveal Melanoma</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-dialog>
              </span>
            </span>
            <!-- (<span class="info--text">{{ selected_event }}</span>) -->
          </v-card-title>
          <event-pancancer-psi ref="event_psi" :event-id="selected_event"
            @isshow="isShowPsiPancanBoxplot"></event-pancancer-psi>
        </v-card>
      </v-col>

      <!-- gene-pancancer-exp-distribution -->
      <v-col cols="12" sm="12" lg="12" md="12" v-show="isShowExpBoxPlot" class="v-step-9">
        <v-card>
          <v-card-title class="justify-start grey lighten-2" style="padding: 8px">
            <span class="font-weight-bold">Expression Distribution of Gene (<span class="info--text">{{
              gene_select
                }}</span>) in TCGA Pan-Cancer
              <span class="mx-2">
                <v-dialog v-model="dialog" :retain-focus="false">
                  <template v-slot:activator="{}">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn color="" icon small @click.stop="dialog = true" v-bind="attrs" v-on="on">
                          <v-icon>mdi-help-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Click here to get the extension of tumor
                        abbreviations.</span>
                    </v-tooltip>
                  </template>
                  <v-card style="left: 25%; width: 50%">
                    <v-card-title class="font-weight-bold grey lighten-2" style="padding: 0px 0px 0px 20px">
                      TCGA Project ID - Project Name
                      <v-spacer></v-spacer>
                      <v-btn icon large @click="dialog = false">
                        <v-icon>mdi-close-circle</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-simple-table dense fixed-header height="600px">
                      <template v-slot:default>
                        <thead class="font-weight-bold">
                          <tr>
                            <th class="text-left" style="width: 30%">
                              Project ID
                            </th>
                            <th class="text-left" style="width: 70%">
                              Project Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>TCGA-ACC</td>
                            <td>Adrenocortical Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-BLCA</td>
                            <td>Bladder Urothelial Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-BRCA</td>
                            <td>Breast Invasive Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-CESC</td>
                            <td>
                              Cervical Squamous Cell Carcinoma and Endocervical
                              Adenocarcinoma
                            </td>
                          </tr>
                          <tr>
                            <td>TCGA-CHOL</td>
                            <td>Cholangiocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-COAD</td>
                            <td>Colon Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-DLBC</td>
                            <td>
                              Lymphoid Neoplasm Diffuse Large B-cell Lymphoma
                            </td>
                          </tr>
                          <tr>
                            <td>TCGA-ESCA</td>
                            <td>Esophageal Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-GBM</td>
                            <td>Glioblastoma Multiforme</td>
                          </tr>
                          <tr>
                            <td>TCGA-HNSC</td>
                            <td>Head and Neck Squamous Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-KICH</td>
                            <td>Kidney Chromophobe</td>
                          </tr>
                          <tr>
                            <td>TCGA-KIRC</td>
                            <td>Kidney Renal Clear Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-KIRP</td>
                            <td>Kidney Renal Papillary Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LGG</td>
                            <td>Brain Lower Grade Glioma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LIHC</td>
                            <td>Liver Hepatocellular Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LUAD</td>
                            <td>Lung Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-LUSC</td>
                            <td>Lung Squamous Cell Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-MESO</td>
                            <td>Mesothelioma</td>
                          </tr>
                          <tr>
                            <td>TCGA-OV</td>
                            <td>Ovarian Serous Cystadenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-PAAD</td>
                            <td>Pancreatic Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-PCPG</td>
                            <td>Pheochromocytoma and Paraganglioma</td>
                          </tr>
                          <tr>
                            <td>TCGA-PRAD</td>
                            <td>Prostate Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-READ</td>
                            <td>Rectum Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-SARC</td>
                            <td>Sarcoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-SKCM</td>
                            <td>Skin Cutaneous Melanoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-STAD</td>
                            <td>Stomach Adenocarcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-TGCT</td>
                            <td>Testicular Germ Cell Tumors</td>
                          </tr>
                          <tr>
                            <td>TCGA-THCA</td>
                            <td>Thyroid Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-THYM</td>
                            <td>Thymoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-UCEC</td>
                            <td>Uterine Corpus Endometrial Carcinoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-UCS</td>
                            <td>Uterine Carcinosarcoma</td>
                          </tr>
                          <tr>
                            <td>TCGA-UVM</td>
                            <td>Uveal Melanoma</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                </v-dialog>
              </span>
            </span>
          </v-card-title>
          <gene-pancancer-exp ref="gene_exp" :gene-name="gene_select"
            @isshow="isShowExpPancanBoxplot"></gene-pancancer-exp>
        </v-card>
      </v-col>
    </v-row>
    <!-- </v-card> -->

    <!-- back to top -->
    <back-to-top></back-to-top>

    <!-- User guide -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="guide-btn-style primary" fab small icon v-bind="attrs" v-on="on"
          @click="$tours['myTour'].start()">
          <v-icon color="white">mdi-book-cog</v-icon>
        </v-btn>
      </template>
      <span>User Guide</span>
    </v-tooltip>

    <v-tour name="myTour" :steps="steps" :options="{ highlight: true }"></v-tour>
  </v-container>
</template>

<script>
import * as d3 from "d3";
// import { sliderBottom } from 'd3-simple-slider';
import { getGencodeGenePatternByGenename } from "node/details";
import { getAllGeneNamesFromGeneInfo } from "node/general";
import {
  getExonToProteinByTxID,
  getDomainByTxID,
  getSequenceByTxID,
  getBpsByRange,
} from "node/splicevis.js";
import { getSpliceKnowledge } from "node/browse";
import {
  getASModelsByGenenamFromKnowledge,
  getASModelsByGenenameFromDatasets,
} from "node/browse";
import DatasetsResultByGeneClickable from "./DatasetsResultByGeneClickable";
import EventPancancerPsi from "./EventPancancerPsi";
import GenePancancerExp from "./GenePancancerExp";
import tippy, { followCursor } from "tippy.js";
import "tippy.js/dist/tippy.css";
import BackToTop from "@/components/main/BackToTop";

export default {
  name: "SpliceVis",
  components: {
    DatasetsResultByGeneClickable,
    EventPancancerPsi,
    GenePancancerExp,
    BackToTop,
  },
  data() {
    return {
      breadItems: [
        {
          text: "Home",
          disabled: false,
          href: "/ascancer/home",
        },
        {
          text: "Splicing Visualization",
          disabled: true,
        },
      ],

      steps: [
        {
          target: ".v-step-0",
          content: `1. Input the Gene Name (<span class='font-weight-bold red--text'>required!</span>), 
        Alternative Splicing Type and Event Coordinates, then Submit!`,
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-1",
          content: `2. Visualize the splicing events at the <span class='font-weight-bold info--text'>local genomic region</span> and the
        <span class='font-weight-bold info--text'>whole transcript</span> levels !<br/>
        <span class='font-weight-bold red--text'>Tips</span>: Double-click the blank area to zoom in, 
        single-click the blank area to reset, press and hold down the left mouse to drag.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-2",
          content: `3. Visualize the splicing events at the <span class='font-weight-bold info--text'>protein</span> level !<br/>
        <span class='font-weight-bold' style="color:#42A5F5">Blue rects</span> represent the protein corresponding to the exons 
        on the left panel. <span class='font-weight-bold' style="color:#FF8A80">Pink rects</span> represent the Pfam domains.<br/>
        <span class='font-weight-bold red--text'>Tips</span>: Click the blue rect to show the nucleic acid sequence and 
        the corresponding amino acid residue sequence.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-3",
          content: `4. Click to switch between different transcript levels.`,
          params: {
            enableScrolling: false,
          },
        },
        {
          target: ".v-step-4",
          content: `5. Show all <span class='font-weight-bold info--text'>alternative splicing models</span> of single gene, 
        which were obtained by integrating the CASE and CPSE.<br/>
        <span class='font-weight-bold red--text'>Tips</span>: Click any row to visualize the selected AS Model. Click the filter icon to remove the seleceted AS Model.`,
          params: {
            enableScrolling: true,
          },
        },
        {
          target: ".v-step-5",
          content: `6. Show all <span class='font-weight-bold info--text'>CASE</span> of the selected AS Model.<br/>
        <span class='font-weight-bold red--text'>Tips</span>: Click any row to visualize the selected CASE. Click the filter icon to remove the seleceted AS Model.`,
          params: {
            enableScrolling: true,
          },
        },
        {
          target: ".v-step-6",
          content: `7. Show all <span class='font-weight-bold info--text'>CPSE</span> of the selected AS Model.<br/>
        <span class='font-weight-bold red--text'>Tips</span>: Click any row to visualize the selected CPSE. Click the filter icon to remove the seleceted AS Model.`,
          params: {
            enableScrolling: true,
          },
        },
        {
          target: ".v-step-7",
          content: `8. Show the <span class='font-weight-bold info--text'>transcript information</span> corresponding to the transcript level selected above.`,
          params: {
            enableScrolling: true,
          },
        },
        {
          target: ".v-step-8",
          content: `9. Show the <span class='font-weight-bold info--text'>PSI distribution</span> of the selected splicing event in TCGA 33 cancer types.`,
          params: {
            enableScrolling: true,
          },
        },
        {
          target: ".v-step-9",
          content: `10. Show the <span class='font-weight-bold info--text'>expression distribution</span> of the selected gene in TCGA 33 cancer types.`,
          params: {
            enableScrolling: true,
          },
        },
      ],

      isDisableGo: true,
      isDisableSpliceInOut: true,
      isShowFilterASModel: true,

      // All AS Models of single gene
      headers_as_model: [
        { text: "Index", value: "", align: "start", sortable: false },
        { text: "AS Type", value: "as_type", align: "start", sortable: false },
        {
          text: "AS Model ID",
          value: "as_model_id",
          align: "start",
          sortable: false,
        },
        { text: "Flags", value: "flag", align: "start", sortable: true },
      ],
      as_model_items: [],
      selected_row: [],
      loading_as_model: true,
      currentPage_as_model: 1,
      whichPage_as_model: 1,
      pageSize_as_model: 5,
      totalPages_as_model: 0,
      pageSizes_as_model: [5, 10, 15, 20, 50, 100],
      totalItems_as_model: 0,

      // All Knowledge AS Events of single gene
      selectedHeader: [
        "Gene Name",
        "Cancer Type",
        "AS Type",
        "ORF",
        "Method",
        "Mechanism",
        "Function",
        "PubMed",
        "Network",
        "Explorer",
        "Survival",
        "Staging",
        "Details",
      ],
      headers_knowledge: [
        {
          text: "Event ID",
          value: "event_id",
          align: "center",
          sortable: false,
        },
        {
          text: "AS Model ID",
          value: "as_model_id",
          align: "start",
          sortable: false,
        },
        {
          text: "Gene Name",
          value: "gene_name",
          align: "start",
          sortable: true,
        },
        {
          text: "Ensembl ID",
          value: "ensembl_id",
          align: "start",
          sortable: true,
        },
        { text: "Chromsome", value: "chr", align: "start", sortable: false },
        { text: "Strand", value: "strand", align: "start", sortable: false },
        {
          text: "Cancer Type",
          value: "cancer_name",
          align: "start",
          sortable: true,
        },
        {
          text: "Canonical Transcript",
          value: "ct_ensembl_id",
          align: "start",
          sortable: false,
        },
        {
          text: "Splicing Variant",
          value: "sv_ensembl_id",
          align: "start",
          sortable: false,
        },
        { text: "AS Type", value: "as_type", align: "start", sortable: true },
        {
          text: "Event Coordinates",
          value: "event_coordinates",
          align: "start",
          sortable: false,
        },
        {
          text: "Alt Coordinates",
          value: "alt_coordinates",
          align: "start",
          sortable: false,
        },
        // { text: 'Splice In Isoforms', value: 'splice_in_isoforms', align: 'start', sortable: false, },
        // { text: 'Splice Out Isoforms', value: 'splice_out_isoforms', align: 'start', sortable: false, },
        {
          text: "ORF",
          value: "orf_annotation",
          align: "start",
          sortable: false,
        },
        { text: "Method", value: "methods", align: "start", sortable: false },
        {
          text: "Mechanism",
          value: "regulatory_mechanism",
          align: "start",
          sortable: false,
        },
        {
          text: "Function",
          value: "biological_function",
          align: "start",
          sortable: false,
        },
        {
          text: "Primary Site",
          value: "primary_site",
          align: "start",
          sortable: false,
        },
        { text: "Year", value: "year", align: "start", sortable: true },
        { text: "PubMed", value: "pubmed_id", align: "start", sortable: false },
        { text: "Journal", value: "journal", align: "start", sortable: false },
        { text: "Title", value: "title", align: "start", sortable: false },
        {
          text: "Network",
          value: "regulatory_network",
          align: "start",
          sortable: false,
        },
        {
          text: "Explorer",
          value: "regulatory_explorer",
          align: "start",
          sortable: false,
        },
        {
          text: "Survival",
          value: "survival",
          align: "start",
          sortable: false,
        },
        { text: "Staging", value: "staging", align: "start", sortable: false },
        { text: "Details", value: "details", align: "start", sortable: false },
      ],
      splice_knowledge: [],
      selected_row: [],
      selected_event: null,
      search_knowledge: null,
      loading_knowledge: true,
      pubmedLink: "https://pubmed.ncbi.nlm.nih.gov/",

      currentPage: 1,
      whichPage: 1,
      pageSize: 5,
      totalPages: 0,
      pageSizes: [5, 10, 15, 20, 50],
      totalItems: 0,

      isShowPsiBoxPlot: true,
      isShowExpBoxPlot: true,

      gene_select: null,
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: null,
      gene_error_message: null,

      as_select: null,
      as_items: ["ES", "A3SS", "A5SS", "IR", "MEX"],
      as_message: null,
      as_error_message: null,

      coordinate_select: null, // SPP1 ES
      // coordinate_select: "144903988:144904083:144906483:144906569:144911450:144911522", // PUF60 ES
      // coordinate_select: "88898210:88898249:88901216:88901278:88901197:88901278", // SPP1 A3SS
      // coordinate_select: "144900362:144900455:144900031:144900143:144900031:144900245", // PUF60 A3SS
      // coordinate_select: "88898033:88898101:88896868:88896952:88896868:88897116", // SPP1 A5SS
      // coordinate_select: "144900165:144900245:144900389:144900455:144900362:144900455", // PUF60 A5SS
      // coordinate_select: "63334957:63335142:63335905:63336030:63336226:63336351:63349184:63349317", // TPM1 MEX
      // coordinate_select: "72492815:72492996:72494795:72494961:72495363:72495529:72499069:72499221", // PKM MEX
      // coordinate_select: "19638090:19638161:19638510:19638579", // NDUFA13 IR
      // coordinate_select: "7133604:7133749:7134047:7134116", // DVL2 IR
      coordinate_items: [],
      coordinate_message: null,
      coordinate_error_message: null,

      gencodeGenePattern: [],
      gene_start: null,
      gene_end: null,
      strand: null,
      chr: null,
      transcript: [],
      all_tx_ids: [],
      tx_pro_map: {},
      all_tx_exon: [],
      all_tx_intron: [],
      all_tx_utr: [],
      all_start_codon: [],
      all_stop_codon: [],

      asModelHeight: 0,

      // isShowProteinCoding: true,
      view_select: "protein_coding",

      ensemblLink:
        "https://grch37.ensembl.org/Homo_sapiens/Transcript/Summary?db=core;t=",
      refseqLink: "https://www.ncbi.nlm.nih.gov/nuccore/",
      uniprotLink: "https://www.uniprot.org/uniprot/",
      alphafoldLink: "https://alphafold.ebi.ac.uk/entry/",

      survival_project_items: [
        "TCGA-ACC",
        "TCGA-BLCA",
        "TCGA-BRCA",
        "TCGA-CESC",
        "TCGA-CHOL",
        "TCGA-COAD",
        "TCGA-DLBC",
        "TCGA-ESCA",
        "TCGA-GBM",
        "TCGA-HNSC",
        "TCGA-KICH",
        "TCGA-KIRC",
        "TCGA-KIRP",
        "TCGA-LAML",
        "TCGA-LGG",
        "TCGA-LUAD",
        "TCGA-LUSC",
        "TCGA-MESO",
        "TCGA-OV",
        "TCGA-PAAD",
        "TCGA-PCPG",
        "TCGA-PRAD",
        "TCGA-READ",
        "TCGA-SARC",
        "TCGA-SKCM",
        "TCGA-STAD",
        "TCGA-THCA",
        "TCGA-THYM",
        "TCGA-UCEC",
        "TCGA-UCS",
        "TCGA-UVM",
      ],
      stage_project_items: [
        "TCGA-ACC",
        "TCGA-BLCA",
        "TCGA-BRCA",
        "TCGA-CHOL",
        "TCGA-COAD",
        "TCGA-ESCA",
        "TCGA-HNSC",
        "TCGA-KICH",
        "TCGA-KIRC",
        "TCGA-KIRP",
        "TCGA-LUAD",
        "TCGA-LUSC",
        "TCGA-MESO",
        "TCGA-PAAD",
        "TCGA-READ",
        "TCGA-SKCM",
        "TCGA-STAD",
        "TCGA-THCA",
      ],

      dialog: false,
    };
  },
  created() {
    // console.log(this.$route.query.genename);
    // Firstly, load all genenames from gene_info (because watch gene_select). but, this slows the loading speed
    // this.getAllGeneNamesFromGeneInfo().then(() => {
    if (JSON.stringify(this.$route.query) === "{}") {
      // console.log('query is null');

      // 这里必须异步赋值,才能被监听到
      setTimeout(() => {
        this.gene_select = "EZH2";
        this.getAllASModelsByGenename(); // get all AS Models of gene
      }, 50);

      this.as_select = "ES";
      this.getSpliceKnowledge().then(() => {
        // console.log(this.gene_select);
        if (this.splice_knowledge.length > 0) {
          // default select the first row
          this.coordinate_select = this.splice_knowledge[0].event_coordinates;
          this.changeRoute();

          if (this.as_select == "IR") {
            this.view_select = "all";
          } else {
            this.view_select = "protein_coding";
          }

          this.initStructure(this.view_select);

          this.selected_row = [];
          this.selected_row.push(this.splice_knowledge[0].as_model_id);
          this.selected_event = this.splice_knowledge[0].event_id;
          // let event_info = this.splice_knowledge[0].gene_name + "_" + this.splice_knowledge[0].as_type
          //   + "_" + this.splice_knowledge[0].event_coordinates;
          // console.log(event_info);
        }
      });
    } else if (JSON.stringify(this.$route.query) !== "{}") {
      // if have query

      // this.gene_select = this.$route.query.genename;

      // 这里必须异步赋值, 子组件才能监听到 gene_select 发生变化
      setTimeout(() => {
        this.gene_select = this.$route.query.genename;
        this.getAllASModelsByGenename(); // get all AS Models of gene
      }, 50);

      if (this.$route.query.astype) {
        this.as_select = this.$route.query.astype;
      }
      if (this.$route.query.coordinate) {
        this.coordinate_select = this.$route.query.coordinate;
      }
      if (this.as_select == "IR") {
        this.view_select = "all";
      } else {
        this.view_select = "protein_coding";
      }
      this.initStructure(this.view_select).then(() => {
        this.selected_row = [];
        // 当来自其他页面的跳转时，需手动拼接 as_model_id
        let as_type = this.as_select;
        let strand = this.strand;
        let event_coordinates = this.coordinate_select || "";
        if (event_coordinates) {
          // init the this.selected_event for psi-pancancer-boxplot
          this.selected_event =
            this.gene_select +
            "_" +
            this.chr +
            "_" +
            this.strand +
            "_" +
            this.as_select +
            "_" +
            this.coordinate_select;

          let effect_coordinates;
          if (as_type == "ES") {
            if (event_coordinates.split(":").length == 6) {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(1, 5)
                .join(":");
            } else if (event_coordinates.split(":").length == 8) {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(1, 7)
                .join(":");
            } else if (event_coordinates.split(":").length == 10) {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(1, 9)
                .join(":");
            }
          } else if (as_type == "A3SS") {
            if (strand == "+") {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(1, 6)
                .join(":");
            } else {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(0, 5)
                .join(":");
            }
          } else if (as_type == "A5SS") {
            if (strand == "+") {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(0, 5)
                .join(":");
            } else {
              effect_coordinates = event_coordinates
                .split(":")
                .slice(1, 6)
                .join(":");
            }
          } else if (as_type == "IR") {
            effect_coordinates = event_coordinates
              .split(":")
              .slice(1, 3)
              .join(":");
          } else if (as_type == "MEX") {
            effect_coordinates = event_coordinates
              .split(":")
              .slice(1, 7)
              .join(":");
          }
          let as_model_id =
            this.gene_select +
            "_" +
            this.chr +
            "_" +
            strand +
            "_" +
            as_type +
            "_" +
            effect_coordinates;
          // console.log(as_model_id);
          this.selected_row.push(as_model_id);
        }

        this.getSpliceKnowledge();
      });
    }
    // });

    // Load external svg2pdf js scripts
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src =
      "https://ngdc.cncb.ac.cn/ascancer/api/js/pdfkit.standalone.js";
    document.body.appendChild(script1);

    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://ngdc.cncb.ac.cn/ascancer/api/js/svg-to-pdfkit.js";
    document.body.appendChild(script2);
  },
  mounted() {
    this.getAllGeneNamesFromGeneInfo();

    // 必须放在这里才能访问到子组件属性, 延迟 1.2s, 这种方法舍弃！换成子组件发送事件给父组件
    // setTimeout(() => {
    //   this.isShowExpBoxPlot = this.$refs.gene_exp.isShowExpBoxPlot;
    //   this.isShowPsiBoxPlot = this.$refs.event_psi.isShowPsiBoxPlot;
    // }, 1200);
  },
  computed: {
    getCurrentShowTranscriptName() {
      if (this.view_select == "all") {
        return "All Transcript";
      } else if (this.view_select == "protein_coding") {
        return "Protein-coding Transcript";
      } else if (this.view_select == "splice_in") {
        return "Splice-in Transcript";
      } else if (this.view_select == "splice_out") {
        return "Splice-out Transcript";
      }
    },
    isDisableEventBtn() {
      return this.coordinate_select == null;
    },
    listenMultiData() {
      const { gene_select, as_select, coordinate_select } = this;
      return {
        gene_select,
        as_select,
        coordinate_select,
      };
    },
    selectedHeaders() {
      return this.headers_knowledge.filter((h) =>
        this.selectedHeader.includes(h.text)
      );
    },
  },
  watch: {
    as_model_items(val) {
      if (val) {
        this.loading_as_model = false;
      }
    },
    splice_knowledge(val) {
      if (val) {
        this.loading_knowledge = false;
      }
    },
    gene_search(val) {
      val && val !== this.gene_select && this.querySelections(val);
    },
    gene_select(val) {
      // console.log(val);
      if (val == this.$route.query.genename || val == "EZH2") {
        this.isDisableGo = false;
        this.gene_select = val;
        this.gene_message = null;
      } else if (val == null || val == "") {
        this.isDisableGo = true;
        this.gene_message = "Please enter the gene name.";

        // refresh
        // this.as_select = null;
        // this.coordinate_select = null;
      } else if (val && this.gene_list.includes(val)) {
        this.isDisableGo = false;
        this.gene_select = val;
        this.gene_message = null;
        // this.getSpliceKnowledge();
      } else {
        this.isDisableGo = true;
        // window.alert("Sorry, we cant' find this gene.");
        this.gene_select = null;
      }
    },
    listenMultiData(val) {
      if (val.gene_select && val.as_select && val.coordinate_select) {
        // console.log('yes');
        this.isDisableSpliceInOut = false;
        this.isShowFilterASModel = true;
      } else {
        this.isDisableSpliceInOut = true;
        this.isShowFilterASModel = false;
      }
    },
  },
  methods: {
    async getAllGeneNamesFromGeneInfo() {
      await getAllGeneNamesFromGeneInfo()
        .then((data) => {
          if (data) {
            this.gene_list = data;
          }
        })
        .catch((err) => console.error(err));
    },
    getRequestParams(genename, astype, asmodelid, page, pageSize) {
      let params = {};
      if (genename) {
        params["genename"] = genename;
      }
      if (astype) {
        params["astype"] = astype;
      }
      if (asmodelid) {
        params["asmodelid"] = asmodelid;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    async getSpliceKnowledge() {
      this.loading_knowledge = true;
      const params = this.getRequestParams(
        this.gene_select,
        this.as_select,
        this.selected_row[0],
        this.currentPage,
        this.pageSize
      );
      await getSpliceKnowledge(params)
        .then((data) => {
          // console.log(data);
          this.loading_knowledge = false;
          this.totalItems = data.totalItems;
          this.splice_knowledge = data.items;
          this.currentPage = data.currentPage;
          this.totalPages = data.totalPages;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.whichPage = this.currentPage;
      this.getSpliceKnowledge();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getSpliceKnowledge();
    },
    jumpPage() {
      // console.log(+this.whichPage);
      if (+this.whichPage < 1) {
        this.whichPage = 1;
      }
      if (+this.whichPage > this.totalPages) {
        this.whichPage = this.totalPages;
      }
      this.currentPage = +this.whichPage;
      this.getSpliceKnowledge();
    },
    async getGencodeGenePatternByGenename(filter_arg) {
      let genename, as_type, event_coords;
      if (this.$route.query.genename) {
        genename = this.$route.query.genename;
      }
      if (this.$route.query.astype) {
        as_type = this.$route.query.astype;
      }
      if (this.$route.query.coordinate) {
        event_coords = this.$route.query.coordinate;
      }
      if (genename) {
        await getGencodeGenePatternByGenename(genename)
          .then((result) => {
            if (result) {
              this.gene_start = result[0].start;
              // console.log(this.gene_start);
              this.gene_end = result[0].end;
              // console.log(this.gene_end);
              this.strand = result[0].strand;
              let strand = result[0].strand;
              // console.log(this.strand);
              this.chr = result[0].chr;
              // console.log(this.chr);
              let transcript = result[0]["transcript"];

              let all_transcript = [];
              let all_tx_ids = [];
              let tx_pro_map = {};

              if (filter_arg == "all") {
                // all transcripts
                Object.keys(transcript)
                  .sort()
                  .map((d) => {
                    all_transcript.push(transcript[d]);
                    all_tx_ids.push(
                      transcript[d].transcript_id &&
                      transcript[d].transcript_id.split(".")[0]
                    );
                    // the mapping relationship between transcript_id and protein_id
                    if (transcript[d].transcript_id) {
                      if (transcript[d].protein_id) {
                        tx_pro_map[transcript[d].transcript_id.split(".")[0]] =
                          transcript[d].protein_id.split(".")[0];
                      } else {
                        tx_pro_map[transcript[d].transcript_id.split(".")[0]] =
                          "-";
                      }
                    }
                  });
              } else if (filter_arg == "protein_coding") {
                // protein-coding transcripts
                Object.keys(transcript)
                  .sort()
                  .map((d) => {
                    if (transcript[d].transcript_type == "protein_coding") {
                      all_transcript.push(transcript[d]);
                      all_tx_ids.push(
                        transcript[d].transcript_id &&
                        transcript[d].transcript_id.split(".")[0]
                      );
                      // the mapping relationship between transcript_id and protein_id
                      if (transcript[d].transcript_id) {
                        tx_pro_map[transcript[d].transcript_id.split(".")[0]] =
                          transcript[d].protein_id.split(".")[0];
                      }
                    }
                  });
              } else if (filter_arg == "splice_in") {
                // splice in transcripts
                Object.keys(transcript)
                  .sort()
                  .map((d) => {
                    // console.log(transcript[d]);
                    if (
                      as_type == "ES" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      if (arr && arr.length == 6) {
                        // 3 exons (skip 1)
                        let upstreamES,
                          upstreamEE,
                          altES,
                          altEE,
                          downstreamES,
                          downstreamEE;
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        altES = arr[2];
                        altEE = arr[3];
                        downstreamES = arr[4];
                        downstreamEE = arr[5];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == altES ||
                              v.start == altES - 1 ||
                              v.start == altES + 1) &&
                            (v.end == altEE ||
                              v.end == altEE - 1 ||
                              v.end == altEE + 1)
                          ) {
                            num++;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 3) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else if (arr && arr.length == 8) {
                        // 4 exons (skip 2)
                        let upstreamES,
                          upstreamEE,
                          alt1ES,
                          alt1EE,
                          alt2ES,
                          alt2EE,
                          downstreamES,
                          downstreamEE;
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        alt1ES = arr[2];
                        alt1EE = arr[3];
                        alt2ES = arr[4];
                        alt2EE = arr[5];
                        downstreamES = arr[6];
                        downstreamEE = arr[7];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt1ES ||
                              v.start == alt1ES - 1 ||
                              v.start == alt1ES + 1) &&
                            (v.end == alt1EE ||
                              v.end == alt1EE - 1 ||
                              v.end == alt1EE + 1)
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt2ES ||
                              v.start == alt2ES - 1 ||
                              v.start == alt2ES + 1) &&
                            (v.end == alt2EE ||
                              v.end == alt2EE - 1 ||
                              v.end == alt2EE + 1)
                          ) {
                            num++;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 4) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else if (arr && arr.length == 10) {
                        // 5 exons (skip 3)
                        let upstreamES,
                          upstreamEE,
                          alt1ES,
                          alt1EE,
                          alt2ES,
                          alt2EE,
                          alt3ES,
                          alt3EE,
                          downstreamES,
                          downstreamEE;
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        alt1ES = arr[2];
                        alt1EE = arr[3];
                        alt2ES = arr[4];
                        alt2EE = arr[5];
                        alt2ES = arr[6];
                        alt2EE = arr[7];
                        downstreamES = arr[8];
                        downstreamEE = arr[9];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt1ES ||
                              v.start == alt1ES - 1 ||
                              v.start == alt1ES + 1) &&
                            (v.end == alt1EE ||
                              v.end == alt1EE - 1 ||
                              v.end == alt1EE + 1)
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt2ES ||
                              v.start == alt2ES - 1 ||
                              v.start == alt2ES + 1) &&
                            (v.end == alt2EE ||
                              v.end == alt2EE - 1 ||
                              v.end == alt2EE + 1)
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt3ES ||
                              v.start == alt3ES - 1 ||
                              v.start == alt3ES + 1) &&
                            (v.end == alt3EE ||
                              v.end == alt3EE - 1 ||
                              v.end == alt3EE + 1)
                          ) {
                            num++;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 5) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (
                      as_type == "A3SS" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let flankingES,
                        flankingEE,
                        longES,
                        longEE,
                        shortES,
                        shortEE;
                      if (strand == "+") {
                        flankingES = arr[0];
                        flankingEE = arr[1];
                        longES = arr[2];
                        shortES = arr[3];
                        longEE = arr[4];
                        shortEE = arr[5];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == flankingEE ||
                            v.end == flankingEE - 1 ||
                            v.end == flankingEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == longES ||
                              v.start == longES - 1 ||
                              v.start == longES + 1) &&
                            (v.end == longEE ||
                              v.end == longEE - 1 ||
                              v.end == longEE + 1)
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        flankingES = arr[5];
                        flankingEE = arr[4];
                        longES = arr[3];
                        shortES = arr[2];
                        longEE = arr[1];
                        shortEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.start == flankingEE ||
                            v.start == flankingEE - 1 ||
                            v.start == flankingEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == longEE ||
                              v.start == longEE - 1 ||
                              v.start == longEE + 1) &&
                            (v.end == longES ||
                              v.end == longES - 1 ||
                              v.end == longES + 1)
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (
                      as_type == "A5SS" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let flankingES,
                        flankingEE,
                        longES,
                        longEE,
                        shortES,
                        shortEE;
                      if (strand == "+") {
                        longES = arr[0];
                        shortES = arr[1];
                        shortEE = arr[2];
                        longEE = arr[3];
                        flankingES = arr[4];
                        flankingEE = arr[5];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.start == flankingES ||
                            v.start == flankingES - 1 ||
                            v.start == flankingES + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == longES ||
                              v.start == longES - 1 ||
                              v.start == longES + 1) &&
                            (v.end == longEE ||
                              v.end == longEE - 1 ||
                              v.end == longEE + 1)
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        longES = arr[5];
                        shortES = arr[4];
                        shortEE = arr[3];
                        longEE = arr[2];
                        flankingES = arr[1];
                        flankingEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == flankingES ||
                            v.end == flankingES - 1 ||
                            v.end == flankingES + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == longEE ||
                              v.start == longEE - 1 ||
                              v.start == longEE + 1) &&
                            (v.end == longES ||
                              v.end == longES - 1 ||
                              v.end == longES + 1)
                          ) {
                            num++;
                          }
                        });
                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (
                      as_type == "MEX" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let upstreamES,
                        upstreamEE,
                        firstExonStart,
                        firstExonEnd,
                        secnodExonStart,
                        secnodExonEnd,
                        downstreamES,
                        downstreamEE;
                      if (strand == "+") {
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        firstExonStart = arr[2];
                        firstExonEnd = arr[3];
                        secnodExonStart = arr[4];
                        secnodExonEnd = arr[5];
                        downstreamES = arr[6];
                        downstreamEE = arr[7];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == firstExonStart ||
                              v.start == firstExonStart - 1 ||
                              v.start == firstExonStart + 1) &&
                            (v.end == firstExonEnd ||
                              v.end == firstExonEnd - 1 ||
                              v.end == firstExonEnd + 1)
                          ) {
                            num++;
                          }
                          if (
                            (v.start == secnodExonStart ||
                              v.start == secnodExonStart - 1 ||
                              v.start == secnodExonStart + 1) &&
                            (v.end == secnodExonEnd ||
                              v.end == secnodExonEnd - 1 ||
                              v.end == secnodExonEnd + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 3) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        upstreamES = arr[7];
                        upstreamEE = arr[6];
                        firstExonStart = arr[5];
                        firstExonEnd = arr[4];
                        secnodExonStart = arr[3];
                        secnodExonEnd = arr[2];
                        downstreamES = arr[1];
                        downstreamEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.start == upstreamEE ||
                            v.start == upstreamEE - 1 ||
                            v.start == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == firstExonEnd ||
                              v.start == firstExonEnd - 1 ||
                              v.start == firstExonEnd + 1) &&
                            (v.end == firstExonStart ||
                              v.end == firstExonStart - 1 ||
                              v.end == firstExonStart + 1)
                          ) {
                            num++;
                          }
                          if (
                            (v.start == secnodExonEnd ||
                              v.start == secnodExonEnd - 1 ||
                              v.start == secnodExonEnd + 1) &&
                            (v.end == secnodExonStart ||
                              v.end == secnodExonStart - 1 ||
                              v.end == secnodExonStart + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            v.end == downstreamES ||
                            v.end == downstreamES - 1 ||
                            v.end == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 3) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (as_type == "IR") {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let upstreamES, upstreamEE, downstreamES, downstreamEE;
                      if (strand == "+") {
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        downstreamES = arr[2];
                        downstreamEE = arr[3];
                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            (v.start == upstreamES ||
                              v.start == upstreamES - 1 ||
                              v.start == upstreamES + 1) &&
                            v.end > upstreamEE + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 1) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        upstreamES = arr[3];
                        upstreamEE = arr[2];
                        downstreamES = arr[1];
                        downstreamEE = arr[0];
                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            (v.end == upstreamES ||
                              v.end == upstreamES - 1 ||
                              v.end == upstreamES + 1) &&
                            v.start < upstreamEE - 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 1) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    }
                  });
              } else if (filter_arg == "splice_out") {
                // splice out transcripts
                Object.keys(transcript)
                  .sort()
                  .map((d) => {
                    // console.log(transcript[d]);
                    if (
                      as_type == "ES" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      if (arr && arr.length == 6) {
                        // 3 exons (skip 1)
                        let upstreamES,
                          upstreamEE,
                          altES,
                          altEE,
                          downstreamES,
                          downstreamEE;
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        altES = arr[2];
                        altEE = arr[3];
                        downstreamES = arr[4];
                        downstreamEE = arr[5];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == altES ||
                              v.start == altES - 1 ||
                              v.start == altES + 1) &&
                            (v.end == altEE ||
                              v.end == altEE - 1 ||
                              v.end == altEE + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else if (arr && arr.length == 8) {
                        // 4 exons (skip 2)
                        let upstreamES,
                          upstreamEE,
                          alt1ES,
                          alt1EE,
                          alt2ES,
                          alt2EE,
                          downstreamES,
                          downstreamEE;
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        alt1ES = arr[2];
                        alt1EE = arr[3];
                        alt2ES = arr[4];
                        alt2EE = arr[5];
                        downstreamES = arr[6];
                        downstreamEE = arr[7];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt1ES ||
                              v.start == alt1ES - 1 ||
                              v.start == alt1ES + 1) &&
                            (v.end == alt1EE ||
                              v.end == alt1EE - 1 ||
                              v.end == alt1EE + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            (v.start == alt2ES ||
                              v.start == alt2ES - 1 ||
                              v.start == alt2ES + 1) &&
                            (v.end == alt2EE ||
                              v.end == alt2EE - 1 ||
                              v.end == alt2EE + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else if (arr && arr.length == 10) {
                        // 5 exons (skip 3)
                        let upstreamES,
                          upstreamEE,
                          alt1ES,
                          alt1EE,
                          alt2ES,
                          alt2EE,
                          alt3ES,
                          alt3EE,
                          downstreamES,
                          downstreamEE;
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        alt1ES = arr[2];
                        alt1EE = arr[3];
                        alt2ES = arr[4];
                        alt2EE = arr[5];
                        alt3ES = arr[6];
                        alt3EE = arr[7];
                        downstreamES = arr[8];
                        downstreamEE = arr[9];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == alt1ES ||
                              v.start == alt1ES - 1 ||
                              v.start == alt1ES + 1) &&
                            (v.end == alt1EE ||
                              v.end == alt1EE - 1 ||
                              v.end == alt1EE + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            (v.start == alt2ES ||
                              v.start == alt2ES - 1 ||
                              v.start == alt2ES + 1) &&
                            (v.end == alt2EE ||
                              v.end == alt2EE - 1 ||
                              v.end == alt2EE + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            (v.start == alt3ES ||
                              v.start == alt3ES - 1 ||
                              v.start == alt3ES + 1) &&
                            (v.end == alt3EE ||
                              v.end == alt3EE - 1 ||
                              v.end == alt3EE + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (
                      as_type == "A3SS" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let flankingES,
                        flankingEE,
                        longES,
                        longEE,
                        shortES,
                        shortEE;
                      if (strand == "+") {
                        flankingES = arr[0];
                        flankingEE = arr[1];
                        longES = arr[2];
                        shortES = arr[3];
                        longEE = arr[4];
                        shortEE = arr[5];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == flankingEE ||
                            v.end == flankingEE - 1 ||
                            v.end == flankingEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == shortES ||
                              v.start == shortES - 1 ||
                              v.start == shortES + 1) &&
                            (v.end == shortEE ||
                              v.end == shortEE - 1 ||
                              v.end == shortEE + 1)
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        flankingES = arr[5];
                        flankingEE = arr[4];
                        longES = arr[3];
                        shortES = arr[2];
                        longEE = arr[1];
                        shortEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.start == flankingEE ||
                            v.start == flankingEE - 1 ||
                            v.start == flankingEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == shortEE ||
                              v.start == shortEE - 1 ||
                              v.start == shortEE + 1) &&
                            (v.end == shortES ||
                              v.end == shortES - 1 ||
                              v.end == shortES + 1)
                          ) {
                            num++;
                          }
                        });

                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (
                      as_type == "A5SS" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let flankingES,
                        flankingEE,
                        longES,
                        longEE,
                        shortES,
                        shortEE;
                      if (strand == "+") {
                        longES = arr[0];
                        shortES = arr[1];
                        shortEE = arr[2];
                        longEE = arr[3];
                        flankingES = arr[4];
                        flankingEE = arr[5];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.start == flankingES ||
                            v.start == flankingES - 1 ||
                            v.start == flankingES + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == shortES ||
                              v.start == shortES - 1 ||
                              v.start == shortES + 1) &&
                            (v.end == shortEE ||
                              v.end == shortEE - 1 ||
                              v.end == shortEE + 1)
                          ) {
                            num++;
                          }
                        });
                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        longES = arr[5];
                        shortES = arr[4];
                        shortEE = arr[3];
                        longEE = arr[2];
                        flankingES = arr[1];
                        flankingEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == flankingES ||
                            v.end == flankingES - 1 ||
                            v.end == flankingES + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == shortEE ||
                              v.start == shortEE - 1 ||
                              v.start == shortEE + 1) &&
                            (v.end == shortES ||
                              v.end == shortES - 1 ||
                              v.end == shortES + 1)
                          ) {
                            num++;
                          }
                        });
                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (
                      as_type == "MEX" &&
                      transcript[d].transcript_type == "protein_coding"
                    ) {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let upstreamES,
                        upstreamEE,
                        firstExonStart,
                        firstExonEnd,
                        secnodExonStart,
                        secnodExonEnd,
                        downstreamES,
                        downstreamEE;
                      if (strand == "+") {
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        firstExonStart = arr[2];
                        firstExonEnd = arr[3];
                        secnodExonStart = arr[4];
                        secnodExonEnd = arr[5];
                        downstreamES = arr[6];
                        downstreamEE = arr[7];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.end == upstreamEE ||
                            v.end == upstreamEE - 1 ||
                            v.end == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == firstExonStart ||
                              v.start == firstExonStart - 1 ||
                              v.start == firstExonStart + 1) &&
                            (v.end == firstExonEnd ||
                              v.end == firstExonEnd - 1 ||
                              v.end == firstExonEnd + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            (v.start == secnodExonStart ||
                              v.start == secnodExonStart - 1 ||
                              v.start == secnodExonStart + 1) &&
                            (v.end == secnodExonEnd ||
                              v.end == secnodExonEnd - 1 ||
                              v.end == secnodExonEnd + 1)
                          ) {
                            num++;
                          }
                          if (
                            v.start == downstreamES ||
                            v.start == downstreamES - 1 ||
                            v.start == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 3) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        upstreamES = arr[7];
                        upstreamEE = arr[6];
                        firstExonStart = arr[5];
                        firstExonEnd = arr[4];
                        secnodExonStart = arr[3];
                        secnodExonEnd = arr[2];
                        downstreamES = arr[1];
                        downstreamEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            v.start == upstreamEE ||
                            v.start == upstreamEE - 1 ||
                            v.start == upstreamEE + 1
                          ) {
                            num++;
                          }
                          if (
                            (v.start == firstExonEnd ||
                              v.start == firstExonEnd - 1 ||
                              v.start == firstExonEnd + 1) &&
                            (v.end == firstExonStart ||
                              v.end == firstExonStart - 1 ||
                              v.end == firstExonStart + 1)
                          ) {
                            num = 0;
                          }
                          if (
                            (v.start == secnodExonEnd ||
                              v.start == secnodExonEnd - 1 ||
                              v.start == secnodExonEnd + 1) &&
                            (v.end == secnodExonStart ||
                              v.end == secnodExonStart - 1 ||
                              v.end == secnodExonStart + 1)
                          ) {
                            num++;
                          }
                          if (
                            v.end == downstreamES ||
                            v.end == downstreamES - 1 ||
                            v.end == downstreamES + 1
                          ) {
                            num++;
                          }
                        });
                        if (num == 3) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] = transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    } else if (as_type == "IR") {
                      let arr = event_coords
                        .split(":")
                        .map((d) => +d)
                        .sort((a, b) => a - b); // sort coordinates
                      // console.log(arr);
                      let upstreamES, upstreamEE, downstreamES, downstreamEE;
                      if (strand == "+") {
                        upstreamES = arr[0];
                        upstreamEE = arr[1];
                        downstreamES = arr[2];
                        downstreamEE = arr[3];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            (v.start == upstreamES ||
                              v.start == upstreamES - 1 ||
                              v.start == upstreamES + 1) &&
                            (v.end == upstreamEE ||
                              v.end == upstreamEE - 1 ||
                              v.end == upstreamEE + 1)
                          ) {
                            num++;
                          }
                          if (v.start >= upstreamEE && v.end <= downstreamES) {
                            num = 0;
                          }
                          if (
                            (v.start >= downstreamES ||
                              v.start == downstreamES - 1 ||
                              v.start == downstreamES + 1) &&
                            (v.end == downstreamEE ||
                              v.end == downstreamEE - 1 ||
                              v.end == downstreamEE + 1)
                          ) {
                            num++;
                          }
                        });
                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      } else {
                        upstreamES = arr[3];
                        upstreamEE = arr[2];
                        downstreamES = arr[1];
                        downstreamEE = arr[0];

                        let num = 0;
                        transcript[d].exons.forEach((v, i, a) => {
                          if (
                            (v.start == upstreamEE ||
                              v.start == upstreamEE - 1 ||
                              v.start == upstreamEE + 1) &&
                            (v.end == upstreamES ||
                              v.end == upstreamES - 1 ||
                              v.end == upstreamES + 1)
                          ) {
                            num++;
                          }
                          if (v.start >= downstreamES && v.end <= upstreamEE) {
                            num = 0;
                          }
                          if (
                            (v.start >= downstreamEE ||
                              v.start == downstreamEE - 1 ||
                              v.start == downstreamEE + 1) &&
                            (v.end == downstreamES ||
                              v.end == downstreamES - 1 ||
                              v.end == downstreamES + 1)
                          ) {
                            num++;
                          }
                        });
                        if (num == 2) {
                          all_transcript.push(transcript[d]);
                          all_tx_ids.push(
                            transcript[d].transcript_id &&
                            transcript[d].transcript_id.split(".")[0]
                          );
                          // the mapping relationship between transcript_id and protein_id
                          if (transcript[d].transcript_id) {
                            tx_pro_map[
                              transcript[d].transcript_id.split(".")[0]
                            ] =
                              transcript[d].protein_id &&
                              transcript[d].protein_id.split(".")[0];
                          }
                        }
                      }
                    }
                  });
              }

              // console.log(all_transcript);
              result[0]["transcript"] = all_transcript; // replaced as sorted and filtered transcripts
              this.gencodeGenePattern = result;
              this.transcript = all_transcript;
              this.all_tx_ids = all_tx_ids;
              this.tx_pro_map = tx_pro_map;
              // console.log(this.all_tx_ids)
              // console.log(this.transcript)

              // get all exons coordinate
              let all_tx_exon = [];
              // get all utr coordinate
              let all_tx_utr = [];
              // get all start_codon coordinate
              let all_start_codon = [];
              // get all stop_codon coordinate
              let all_stop_codon = [];
              all_transcript &&
                all_transcript.forEach((value, index, array) => {
                  value.exons.forEach((v, i, a) => {
                    let tx_exon = {};
                    tx_exon["exon_number"] = v.exon_number;
                    tx_exon["exon_id"] = v.exon_id;
                    tx_exon["chr"] = v.chr;
                    tx_exon["start"] = v.start;
                    tx_exon["end"] = v.end;
                    tx_exon["length"] = v.length;
                    tx_exon["strand"] = v.strand;
                    tx_exon["tx"] = value.transcript_name;
                    tx_exon["tx_id"] =
                      value.transcript_id && value.transcript_id.split(".")[0];
                    all_tx_exon.push(tx_exon); // 注意：此处不能写 this.all_tx_exon.push(tx_exon) ,否则 all_tx_exon 会进行不断叠加
                  });

                  value.utr.forEach((v, i, a) => {
                    let tx_utr = {};
                    tx_utr["chr"] = v.chr;
                    tx_utr["start"] = v.start;
                    tx_utr["end"] = v.end;
                    tx_utr["length"] = v.length;
                    tx_utr["strand"] = v.strand;
                    tx_utr["tx"] = value.transcript_name;
                    tx_utr["tx_id"] =
                      value.transcript_id && value.transcript_id.split(".")[0];
                    all_tx_utr.push(tx_utr);
                  });

                  value.start_codon.forEach((v, i, a) => {
                    let start_codon = {};
                    start_codon["chr"] = v.chr;
                    start_codon["start"] = v.start;
                    start_codon["end"] = v.end;
                    start_codon["length"] = v.length;
                    start_codon["strand"] = v.strand;
                    start_codon["tx"] = value.transcript_name;
                    start_codon["tx_id"] =
                      value.transcript_id && value.transcript_id.split(".")[0];
                    all_start_codon.push(start_codon);
                  });

                  value.stop_codon.forEach((v, i, a) => {
                    let stop_codon = {};
                    stop_codon["chr"] = v.chr;
                    stop_codon["start"] = v.start;
                    stop_codon["end"] = v.end;
                    stop_codon["length"] = v.length;
                    stop_codon["strand"] = v.strand;
                    stop_codon["tx"] = value.transcript_name;
                    stop_codon["tx_id"] =
                      value.transcript_id && value.transcript_id.split(".")[0];
                    all_stop_codon.push(stop_codon);
                  });
                });
              this.all_tx_exon = all_tx_exon;
              // console.log(this.all_tx_exon);
              this.all_tx_utr = all_tx_utr;
              // console.log(this.all_tx_utr);
              this.all_start_codon = all_start_codon;
              // console.log(this.all_start_codon);
              this.all_stop_codon = all_stop_codon;
              // console.log(this.all_stop_codon);

              // get all introns coordinate
              let all_tx_intron = [];
              all_transcript &&
                all_transcript.forEach((value, index, array) => {
                  value.exons.forEach((v, i, a) => {
                    if (i < value.exons.length - 1 && v.strand == "+") {
                      let tx_intron = {};
                      tx_intron["start"] = v.end;
                      tx_intron["end"] = a[i + 1].start;
                      tx_intron["tx"] = value.transcript_name;
                      tx_intron["tx_id"] =
                        value.transcript_id &&
                        value.transcript_id.split(".")[0];
                      all_tx_intron.push(tx_intron);
                    }

                    if (i < value.exons.length - 1 && v.strand == "-") {
                      let tx_intron = {};
                      tx_intron["end"] = v.start;
                      tx_intron["start"] = a[i + 1].end;
                      tx_intron["tx"] = value.transcript_name;
                      tx_intron["tx_id"] =
                        value.transcript_id &&
                        value.transcript_id.split(".")[0];
                      all_tx_intron.push(tx_intron);
                    }
                  });
                });
              this.all_tx_intron = all_tx_intron;
              // console.log(this.all_tx_intron);
            }
          })
          .catch((err) => {
            console.error(err);
            console.error("There is no gencode gene pattern of", genename);
          });
      }
    },
    querySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter((e) => {
          let pattern = new RegExp(v, "ig");
          return pattern.test(e);
        });
        this.gene_loading = false;
        // show the no data tips when the gene_search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500);
    },
    async initStructure(filter_arg) {
      const margin = { top: 0, right: 10, bottom: 15, left: 50 };
      const width = 300;
      const exonColor = "#42A5F5";
      const asColor = "#FF7043";
      const hoverColor = "#eec42d";
      const utrColor = "white";
      const domainColor = "#FF8A80";
      const rectHeight = 8;
      const space = 20;

      if (this.coordinate_select) {
        this.asModelHeight = 30;
      } else {
        this.asModelHeight = 0;
      }
      let asModelHeight = this.asModelHeight;
      const nodesHeight = asModelHeight / 2;

      // request data (getGencodeGenePatternByGenename)
      // let filter_arg = "protein_coding";
      let all_transcript_numbers,
        height,
        start,
        end,
        strand,
        all_tx_ids,
        tx_pro_map,
        exons,
        introns,
        utrs,
        start_codons,
        stop_codons,
        as_type = this.as_select,
        event_coords = this.coordinate_select;
      // console.log(as_type);
      // console.log(event_coords);
      await this.getGencodeGenePatternByGenename(filter_arg).then(() => {
        all_transcript_numbers = this.transcript.length;
        height =
          space * all_transcript_numbers +
          margin.top +
          margin.bottom +
          asModelHeight;
        start = this.gene_start;
        end = this.gene_end;
        strand = this.strand;
        all_tx_ids = this.all_tx_ids;
        tx_pro_map = this.tx_pro_map;
        // console.log(tx_pro_map);
        exons = this.all_tx_exon;
        // console.log(exons.length);
        introns = this.all_tx_intron;
        // console.log(introns.length);
        utrs = this.all_tx_utr;
        // console.log(utrs.length);
        start_codons = this.all_start_codon;
        stop_codons = this.all_stop_codon;
      });
      // console.log(height);

      // sort function based on tx_id, in order to sort the y-axis transcript_name
      let compare = function (obj1, obj2) {
        let val1 = obj1.tx_id;
        let val2 = obj2.tx_id;
        // 注意：此处不能写成 return val1 - val2
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      };

      ////////////////////////// Show Transcript Structures //////////////////////////
      function showTranscriptStructure() {
        // This place can't be d3.select("svg"), because of conflicting with D3 chart svg.
        const svg = d3
          .select("div#allIsoform > svg")
          .attr("viewBox", [0, 0, width, height])
          .on("click", reSet);

        const zoomin = d3.select("div#allIsoform .zoomin");
        // console.log(zoomin);
        zoomin.on("click", zoomIn);
        const zoomout = d3.select("div#allIsoform .zoomout");
        zoomout.on("click", zoomOut);
        const eventfocus = d3.select("div#allIsoform .eventfocus");
        eventfocus.on("click", eventFocus);
        const reset = d3.select("div#allIsoform .reset");
        reset.on("click", reSet);

        // Clip Off Zoom Overflow
        svg
          .append("clipPath")
          .attr("id", "clipRect")
          .append("rect")
          .attr("x", margin.left - 1)
          .attr("y", margin.top)
          .attr("width", width - margin.left - margin.right + 1)
          .attr("height", height);

        // plot X axis
        let xScale = d3
          .scaleLinear()
          .domain([start, end])
          .range([margin.left, width - margin.right]);
        let xAxis = d3
          .axisBottom(xScale)
          .ticks(3)
          .tickSize(2)
          .tickSizeOuter(0)
          .tickPadding(1)
          .tickFormat(d3.format(",.0f"));
        svg
          .append("g")
          .attr("class", "x-axis")
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .call(xAxis)
          .call((g) => g.selectAll(".domain").attr("stroke-width", "0.3")) // x 轴
          .call((g) => g.selectAll(".tick line").attr("stroke-width", "0.3")) // x 轴 刻度线
          .call((g) =>
            g
              .selectAll(".tick text")
              .attr("font-size", "4.5")
              .attr("font-family", "Arial")
          ) // x 轴 刻度文字
          .attr("clip-path", "url(#clipRect)");

        // slider
        // const sliderRange = sliderBottom(xScale).ticks(0).tickPadding(-18)
        //   .tickFormat(d3.format(',.0f')).default([start, end])
        //   .handle(d3.symbol()
        //     .type(d3.symbolCircle)
        //     .size(10))
        //   .fill("#206595")
        //   .on('onchange', val => {
        //     // console.log(val);
        //     updateTranscriptStructure(val);
        //   });
        // svg.append('g')
        //   .attr('transform', `translate(0, ${height - margin.bottom + 15})`)
        //   .call(sliderRange)
        // .attr('clip-path', 'url(#clipRect)')

        // change the slider style
        // d3.selectAll('g.parameter-value > text').attr("font-size", "4.5").attr("font-family", "Arial");
        // d3.selectAll('g.slider > line.track').attr("x1", margin.left).attr("x2", width - margin.right);
        // d3.selectAll('g.slider > line.track-inset').attr("x1", margin.left).attr("x2", width - margin.right);
        // d3.selectAll('g.slider > line.track-overlay').attr("x1", margin.left).attr("x2", width - margin.right).attr("stroke-width", "20"); // default stroke-width=40

        // sort exons based on tx_id(ensmebl_transcript_id), this is must be done before plot Y axis.
        exons.sort(compare);
        // console.log(exons.sort(compare));

        // plot Y axis
        let yScale = d3
          .scaleBand()
          .domain(
            exons.map(function (d) {
              return d.tx_id;
            })
          )
          .range([height - margin.bottom, asModelHeight])
          .padding(1);
        let yAxis = d3.axisLeft(yScale);
        svg
          .append("g")
          .attr("class", "y-axis")
          .attr("transform", `translate(${margin.left},${rectHeight / 2})`)
          .call(yAxis)
          .call((g) => g.select(".domain").remove())
          .call((g) => g.selectAll(".tick line").remove())
          .call((g) =>
            g
              .selectAll(".tick text")
              .attr("font-size", "4.5")
              .attr("font-family", "Arial")
              .attr("font-weight", "bold")
          );

        // plot exons rects
        svg
          .append("g")
          .attr("class", "exons")
          .selectAll()
          .data(exons)
          .join("rect")
          .attr("x", (d) => xScale(d.start))
          .attr("y", (d) => yScale(d.tx_id))
          .attr("width", (d) => xScale(d.end) - xScale(d.start))
          .attr("height", rectHeight)
          .attr("rx", 1) // set border-radius
          .attr("stroke", "rgb(0,0,0)") // set border color
          .attr("stroke-width", 0.3) // set border width
          .attr("fill", exonColor)
          .style("cursor", "auto")
          .attr("clip-path", "url(#clipRect)")
          .on("mouseover", function () {
            d3.select(this).transition().attr("fill", hoverColor);
          })
          .on("mouseout", function () {
            d3.select(this).transition().attr("fill", exonColor);
          });
        // add exons tooltips using Tippy.js
        let exon_rects = d3.selectAll(".exons rect");
        if (strand == "+") {
          exon_rects.attr("data-tippy-content", (d, i) => {
            return `<div>Exon Number: ${d.exon_number}</div>
             <div>Exon ID: ${d.exon_id.split(".")[0]}</div>
             <div>Chr: ${d.chr}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>
             <div>Length: ${d.length}</div>`;
          });
        } else {
          exon_rects.attr("data-tippy-content", (d, i) => {
            return `<div>Exon Number: ${d.exon_number}</div>
             <div>Exon ID: ${d.exon_id.split(".")[0]}</div>
             <div>Chr: ${d.chr}</div>
             <div>Start: ${d.end}</div>
             <div>End: ${d.start}</div>
             <div>Length: ${d.length}</div>`;
          });
        }
        tippy(exon_rects.nodes(), {
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 200,
          delay: 0,
          duration: [0, 0],
        });

        // plot introns lines
        svg
          .append("g")
          .attr("class", "introns")
          .selectAll()
          .data(introns)
          .join("line")
          .attr("x1", (d) => xScale(d.start))
          .attr("y1", (d) => yScale(d.tx_id))
          .attr("x2", (d) => xScale(d.end))
          .attr("y2", (d) => yScale(d.tx_id))
          .attr("transform", `translate(0,${rectHeight / 2})`)
          .attr("stroke", "grey")
          .attr("stroke-width", "0.5")
          .attr("clip-path", "url(#clipRect)");

        // plot utrs rects
        svg
          .append("g")
          .attr("class", "utrs")
          .selectAll()
          .data(utrs)
          .join("rect")
          .attr("x", (d) => xScale(d.start))
          .attr("y", (d) => yScale(d.tx_id))
          .attr("width", (d) => xScale(d.end) - xScale(d.start))
          .attr("height", rectHeight / 2)
          .attr("transform", `translate(0,${rectHeight / 4})`)
          .attr("rx", 0.5) // set border-radius
          .attr("stroke", "rgb(0,0,0)") // set border color
          .attr("stroke-width", 0.3) // set border width
          .attr("fill", utrColor)
          .style("cursor", "auto")
          .attr("clip-path", "url(#clipRect)")
          .on("mouseover", function () {
            d3.select(this).transition().attr("fill", hoverColor);
          })
          .on("mouseout", function () {
            d3.select(this).transition().attr("fill", utrColor);
          });
        // add utrs tooltips using Tippy.js
        let utr_rects = d3.selectAll(".utrs rect");
        if (strand == "+") {
          utr_rects.attr("data-tippy-content", (d, i) => {
            return `<div>UTR</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>
             <div>Length: ${d.length}</div>`;
          });
        } else {
          utr_rects.attr("data-tippy-content", (d, i) => {
            return `<div>UTR</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.end}</div>
             <div>End: ${d.start}</div>
             <div>Length: ${d.length}</div>`;
          });
        }
        tippy(utr_rects.nodes(), {
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 200,
          delay: 0,
          duration: [0, 0],
        });

        // plot start_codon
        svg
          .append("g")
          .attr("class", "start-codons")
          .selectAll()
          .data(start_codons)
          .join("circle")
          .attr("cx", (d) => xScale(d.start + 1))
          .attr("cy", (d) => yScale(d.tx_id) + 4)
          .attr("r", 0.8)
          .attr("fill", "red")
          .attr("stroke", "black")
          .attr("stroke-width", "0.3")
          .attr("clip-path", "url(#clipRect)")
          .on("mouseover", function () {
            d3.select(this)
              .transition()
              .attr("fill", hoverColor)
              .attr("r", 2)
              .attr("stroke-width", "0.5");
          })
          .on("mouseout", function () {
            d3.select(this)
              .transition()
              .attr("fill", "red")
              .attr("r", 0.8)
              .attr("stroke-width", "0.3");
          });
        // add start_codons tooltips using Tippy.js
        let start_codon = d3.selectAll(".start-codons circle");
        start_codon.attr("data-tippy-content", (d, i) => {
          return `<div>Start Codon</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>`;
        });
        tippy(start_codon.nodes(), {
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 200,
          delay: 0,
          duration: [0, 0],
        });

        // plot stop_codon
        svg
          .append("g")
          .attr("class", "stop-codons")
          .selectAll()
          .data(stop_codons)
          .join("circle")
          .attr("cx", (d) => xScale(d.start + 1))
          .attr("cy", (d) => yScale(d.tx_id) + 4)
          .attr("r", 0.8)
          .attr("fill", "red")
          .attr("stroke", "black")
          .attr("stroke-width", "0.3")
          .attr("clip-path", "url(#clipRect)")
          .on("mouseover", function () {
            d3.select(this)
              .transition()
              .attr("fill", hoverColor)
              .attr("r", 2)
              .attr("stroke-width", "0.5");
          })
          .on("mouseout", function () {
            d3.select(this)
              .transition()
              .attr("fill", "red")
              .attr("r", 0.8)
              .attr("stroke-width", "0.3");
          });
        // add stop_codons tooltips using Tippy.js
        let stop_codon = d3.selectAll(".stop-codons circle");
        stop_codon.attr("data-tippy-content", (d, i) => {
          return `<div>Stop Codon</div>
             <div>Chr: ${d.chr}</div>
             <div>Strand: ${d.strand}</div>
             <div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>`;
        });
        tippy(stop_codon.nodes(), {
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 200,
          delay: 0,
          duration: [0, 0],
        });

        ////////////////////////// plot AS Model
        function plotASModel(as_model_exons, as_model_introns) {
          // console.log(as_model_exons);

          let as_model = svg.append("g").attr("class", "as-model");

          // plot Y axis of AS Model
          let yScale_as_model = d3
            .scaleBand()
            .domain(
              as_model_exons.map(function (d) {
                return d.name;
              })
            )
            .range([margin.top, asModelHeight])
            .padding(1);
          let yAxis_as_model = d3.axisLeft(yScale_as_model);
          as_model
            .append("g")
            .attr("class", "y-axis-as-model")
            .attr("transform", `translate(${margin.left},${rectHeight / 2})`)
            .call(yAxis_as_model)
            .call((g) => g.select(".domain").remove())
            .call((g) => g.selectAll(".tick line").remove())
            .call((g) =>
              g
                .selectAll(".tick text")
                .attr("font-size", "4.5")
                .attr("font-family", "Arial")
                .attr("font-weight", "bold")
            );

          // plot exons of AS Model
          as_model
            .append("g")
            .attr("class", "exons-as-model")
            .selectAll()
            .data(as_model_exons)
            .join("rect")
            .attr("x", (d) => xScale(d.start))
            .attr("y", (d) => yScale_as_model(d.name))
            .attr("width", (d) => xScale(d.end) - xScale(d.start))
            .attr("height", rectHeight)
            .attr("rx", 1) // set border-radius
            .attr("stroke", "rgb(0,0,0)") // set border color
            .attr("stroke-width", 0.3) // set border width
            .attr("fill", (d) => {
              return d.color;
            })
            .style("cursor", "auto")
            .attr("clip-path", "url(#clipRect)")
            .on("mouseover", function () {
              // console.log(as_model_exons);
              d3.select(this).transition().attr("fill", hoverColor);
            })
            .on("mouseout", function () {
              d3.select(this)
                .transition()
                .attr("fill", (d) => {
                  return d.color;
                });
            });
          // add exons tooltips using Tippy.js
          let exon_rects = d3.selectAll(".exons-as-model rect");
          if (strand == "+") {
            exon_rects.attr("data-tippy-content", (d, i) => {
              return `<div>Start: ${d.start}</div>
             <div>End: ${d.end}</div>
             <div>Length: ${d.length}</div>`;
            });
          } else {
            exon_rects.attr("data-tippy-content", (d, i) => {
              return `<div>Start: ${d.end}</div>
             <div>End: ${d.start}</div>
             <div>Length: ${d.length}</div>`;
            });
          }

          tippy(exon_rects.nodes(), {
            allowHTML: true,
            placement: "left",
            interactive: true,
            interactiveDebounce: 0,
            appendTo: () => document.body,
            // followCursor: 'horizontal',
            // plugins: [followCursor],
            maxWidth: 200,
            delay: 0,
            duration: [0, 0],
          });

          // plot introns of AS Model
          svg
            .append("g")
            .attr("class", "introns-as-model")
            .selectAll()
            .data(as_model_introns)
            .join("line")
            .attr("x1", (d) => xScale(d.start))
            .attr("y1", (d) => yScale_as_model(d.name))
            .attr("x2", (d) => xScale(d.end))
            .attr("y2", (d) => yScale_as_model(d.name))
            .attr("transform", `translate(0,${rectHeight / 2})`)
            .attr("stroke", "grey")
            .attr("stroke-width", "0.5")
            .attr("clip-path", "url(#clipRect)");
        }
        ////////////////////////// Plot Links for the AS Event Model
        function plotNodesAndLinks(as_type, nodes_links, arc) {
          let as_model = d3.select("g.as-model");
          // Add the arc for the AS event model (set arc color based on AS Type)
          if (as_type == "ES") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                // console.log(nodes_links.links.length);
                // 3 exons(skip 1)
                if (nodes_links.links && nodes_links.links.length == 3) {
                  if (d.source == 2 && d.target == 5) {
                    return "red";
                  } else {
                    return "black";
                  }
                  // 4 exons(skip 2)
                } else if (nodes_links.links && nodes_links.links.length == 4) {
                  if (d.source == 2 && d.target == 7) {
                    return "red";
                  } else {
                    return "black";
                  }
                  // 5 exons(skip 3)
                } else if (nodes_links.links && nodes_links.links.length == 5) {
                  if (d.source == 2 && d.target == 9) {
                    return "red";
                  } else {
                    return "black";
                  }
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "A3SS") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (d.source == 2 && d.target == 4) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "A5SS") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (d.source == 4 && d.target == 5) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "MEX") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (
                  (d.source == 2 && d.target == 5) ||
                  (d.source == 6 && d.target == 7)
                ) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "IR") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (d.source == 2 && d.target == 3) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          }
        }
        ////////////////////////// Update Links for the AS Event Model
        function updateNodesAndLinks(as_type, nodes_links, arc) {
          let as_model = d3.select("g.as-model");
          as_model.selectAll("path").remove();
          // Update the arc for the AS event model
          if (as_type == "ES") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                // console.log(nodes_links.links.length);
                // 3 exons(skip 1)
                if (nodes_links.links && nodes_links.links.length == 3) {
                  if (d.source == 2 && d.target == 5) {
                    return "red";
                  } else {
                    return "black";
                  }
                  // 4 exons(skip 2)
                } else if (nodes_links.links && nodes_links.links.length == 4) {
                  if (d.source == 2 && d.target == 7) {
                    return "red";
                  } else {
                    return "black";
                  }
                  // 5 exons(skip 3)
                } else if (nodes_links.links && nodes_links.links.length == 5) {
                  if (d.source == 2 && d.target == 9) {
                    return "red";
                  } else {
                    return "black";
                  }
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "A3SS") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (d.source == 2 && d.target == 4) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "A5SS") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (d.source == 4 && d.target == 5) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "MEX") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (
                  (d.source == 2 && d.target == 5) ||
                  (d.source == 6 && d.target == 7)
                ) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          } else if (as_type == "IR") {
            as_model
              .selectAll()
              .data(nodes_links.links)
              .join("path")
              .attr("d", arc)
              .attr("fill", "none")
              .attr("stroke", (d) => {
                if (d.source == 2 && d.target == 3) {
                  return "red";
                } else {
                  return "black";
                }
              })
              .attr("stroke-width", "0.5")
              .attr("clip-path", "url(#clipRect)");
          }
        }
        ////////////////////////// Plot AS Model extent rect
        function plotASModelExtent(event_coords) {
          let arr = event_coords
            .split(":")
            .map((d) => +d)
            .sort((a, b) => a - b);
          let start = arr[0] - 10;
          let end = arr[arr.length - 1] + 10;
          let as_model_rect = [{ start: start, end: end }];
          svg
            .append("g")
            .attr("class", "as-model-extent")
            .selectAll()
            .data(as_model_rect)
            .join("rect")
            .attr("x", (d) => xScale(d.start))
            .attr("y", 0)
            .attr("width", (d) => xScale(d.end) - xScale(d.start))
            .attr("height", height - margin.bottom)
            .attr("rx", 2) // set border-radius
            .attr("stroke", "red")
            .attr("stroke-dasharray", "1,1")
            .attr("fill", "none")
            .attr("stroke-width", "0.5")
            .attr("clip-path", "url(#clipRect)");
        }

        ////////////////////////// Plot alternative splicing events
        function plotASEvents(as_type, event_coords) {
          if (as_type && event_coords) {
            // exon skipped (ES)
            if (as_type == "ES") {
              let arr = event_coords
                .split(":")
                .map((d) => +d)
                .sort((a, b) => a - b); // sort coordinates
              // console.log(arr);
              let as_model_exons, as_model_introns, nodes_links, ES_arc;
              if (arr.length == 6) {
                // ES --- 3 exons
                let upstreamES,
                  upstreamEE,
                  altES,
                  altEE,
                  downstreamES,
                  downstreamEE;
                upstreamES = arr[0];
                upstreamEE = arr[1];
                altES = arr[2];
                altEE = arr[3];
                downstreamES = arr[4];
                downstreamEE = arr[5];
                as_model_exons = [
                  {
                    start: upstreamES,
                    end: upstreamEE,
                    length: upstreamEE - upstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: altES,
                    end: altEE,
                    length: altEE - altES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: downstreamES,
                    end: downstreamEE,
                    length: downstreamEE - downstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: upstreamEE, end: altES, name: "AS Model" },
                  { start: altEE, end: downstreamES, name: "AS Model" },
                ];
                nodes_links = {
                  nodes: [
                    {
                      id: 1,
                      coordinate: upstreamES,
                    },
                    {
                      id: 2,
                      coordinate: upstreamEE,
                    },
                    {
                      id: 3,
                      coordinate: altES,
                    },
                    {
                      id: 4,
                      coordinate: altEE,
                    },
                    {
                      id: 5,
                      coordinate: downstreamES,
                    },
                    {
                      id: 6,
                      coordinate: downstreamEE,
                    },
                  ],
                  links: [
                    {
                      source: 2,
                      target: 3,
                    },
                    {
                      source: 4,
                      target: 5,
                    },
                    {
                      source: 2,
                      target: 5,
                    },
                  ],
                };
                const allNodes = nodes_links.nodes.map((d) => d.coordinate);
                // console.log(allNodes);
                const idToNode = {};
                nodes_links.nodes.forEach(function (n) {
                  idToNode[n.id] = n;
                });
                ES_arc = (d) => {
                  if (d.source == 2 && d.target == 5) {
                    let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                    let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                    return [
                      "M",
                      start,
                      nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                      "A", // This means we're gonna build an elliptical arc
                      (start - end) / 2, // major axis
                      (start - end) / 6, //minor axis
                      0,
                      0,
                      start < end ? 0 : 1, // arc lower
                      end,
                      nodesHeight + rectHeight / 2,
                    ].join(" ");
                  } else {
                    let start = xScale(idToNode[d.source].coordinate);
                    let end = xScale(idToNode[d.target].coordinate);
                    return [
                      "M",
                      start,
                      nodesHeight + rectHeight / 2,
                      "A",
                      (start - end) / 2, // major axis
                      (start - end) / 6, //minor axis
                      0,
                      0,
                      start < end ? 1 : 0, // arc upper
                      end,
                      nodesHeight + rectHeight / 2,
                    ].join(" ");
                  }
                };
              } else if (arr.length == 8) {
                // ES --- 4 exons
                let upstreamES,
                  upstreamEE,
                  alt1ES,
                  alt1EE,
                  alt2ES,
                  alt2EE,
                  downstreamES,
                  downstreamEE;
                upstreamES = arr[0];
                upstreamEE = arr[1];
                alt1ES = arr[2];
                alt1EE = arr[3];
                alt2ES = arr[4];
                alt2EE = arr[5];
                downstreamES = arr[6];
                downstreamEE = arr[7];
                as_model_exons = [
                  {
                    start: upstreamES,
                    end: upstreamEE,
                    length: upstreamEE - upstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: alt1ES,
                    end: alt1EE,
                    length: alt1EE - alt1ES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: alt2ES,
                    end: alt2EE,
                    length: alt2EE - alt2ES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: downstreamES,
                    end: downstreamEE,
                    length: downstreamEE - downstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: upstreamEE, end: alt1ES, name: "AS Model" },
                  { start: alt1EE, end: alt2ES, name: "AS Model" },
                  { start: alt2EE, end: downstreamES, name: "AS Model" },
                ];
                nodes_links = {
                  nodes: [
                    {
                      id: 1,
                      coordinate: upstreamES,
                    },
                    {
                      id: 2,
                      coordinate: upstreamEE,
                    },
                    {
                      id: 3,
                      coordinate: alt1ES,
                    },
                    {
                      id: 4,
                      coordinate: alt1EE,
                    },
                    {
                      id: 5,
                      coordinate: alt2ES,
                    },
                    {
                      id: 6,
                      coordinate: alt2EE,
                    },
                    {
                      id: 7,
                      coordinate: downstreamES,
                    },
                    {
                      id: 8,
                      coordinate: downstreamEE,
                    },
                  ],
                  links: [
                    {
                      source: 2,
                      target: 3,
                    },
                    {
                      source: 4,
                      target: 5,
                    },
                    {
                      source: 6,
                      target: 7,
                    },
                    {
                      source: 2,
                      target: 7,
                    },
                  ],
                };
                const allNodes = nodes_links.nodes.map((d) => d.coordinate);
                // console.log(allNodes);
                const idToNode = {};
                nodes_links.nodes.forEach(function (n) {
                  idToNode[n.id] = n;
                });
                ES_arc = (d) => {
                  if (d.source == 2 && d.target == 7) {
                    let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                    let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                    return [
                      "M",
                      start,
                      nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                      "A", // This means we're gonna build an elliptical arc
                      (start - end) / 2, // major axis
                      (start - end) / 6, //minor axis
                      0,
                      0,
                      start < end ? 0 : 1, // arc lower
                      end,
                      nodesHeight + rectHeight / 2,
                    ].join(" ");
                  } else {
                    let start = xScale(idToNode[d.source].coordinate);
                    let end = xScale(idToNode[d.target].coordinate);
                    return [
                      "M",
                      start,
                      nodesHeight + rectHeight / 2,
                      "A",
                      (start - end) / 2, // major axis
                      (start - end) / 6, //minor axis
                      0,
                      0,
                      start < end ? 1 : 0, // arc upper
                      end,
                      nodesHeight + rectHeight / 2,
                    ].join(" ");
                  }
                };
              } else if (arr.length == 10) {
                // ES --- 5 exons
                let upstreamES,
                  upstreamEE,
                  alt1ES,
                  alt1EE,
                  alt2ES,
                  alt2EE,
                  alt3ES,
                  alt3EE,
                  downstreamES,
                  downstreamEE;
                upstreamES = arr[0];
                upstreamEE = arr[1];
                alt1ES = arr[2];
                alt1EE = arr[3];
                alt2ES = arr[4];
                alt2EE = arr[5];
                alt3ES = arr[6];
                alt3EE = arr[7];
                downstreamES = arr[8];
                downstreamEE = arr[9];
                as_model_exons = [
                  {
                    start: upstreamES,
                    end: upstreamEE,
                    length: upstreamEE - upstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: alt1ES,
                    end: alt1EE,
                    length: alt1EE - alt1ES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: alt2ES,
                    end: alt2EE,
                    length: alt2EE - alt2ES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: alt3ES,
                    end: alt3EE,
                    length: alt3EE - alt3ES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: downstreamES,
                    end: downstreamEE,
                    length: downstreamEE - downstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: upstreamEE, end: alt1ES, name: "AS Model" },
                  { start: alt1EE, end: alt2ES, name: "AS Model" },
                  { start: alt2EE, end: alt3ES, name: "AS Model" },
                  { start: alt3EE, end: downstreamES, name: "AS Model" },
                ];
                nodes_links = {
                  nodes: [
                    {
                      id: 1,
                      coordinate: upstreamES,
                    },
                    {
                      id: 2,
                      coordinate: upstreamEE,
                    },
                    {
                      id: 3,
                      coordinate: alt1ES,
                    },
                    {
                      id: 4,
                      coordinate: alt1EE,
                    },
                    {
                      id: 5,
                      coordinate: alt2ES,
                    },
                    {
                      id: 6,
                      coordinate: alt2EE,
                    },
                    {
                      id: 7,
                      coordinate: alt3ES,
                    },
                    {
                      id: 8,
                      coordinate: alt3EE,
                    },
                    {
                      id: 9,
                      coordinate: downstreamES,
                    },
                    {
                      id: 10,
                      coordinate: downstreamEE,
                    },
                  ],
                  links: [
                    {
                      source: 2,
                      target: 3,
                    },
                    {
                      source: 4,
                      target: 5,
                    },
                    {
                      source: 6,
                      target: 7,
                    },
                    {
                      source: 8,
                      target: 9,
                    },
                    {
                      source: 2,
                      target: 9,
                    },
                  ],
                };
                const allNodes = nodes_links.nodes.map((d) => d.coordinate);
                // console.log(allNodes);
                const idToNode = {};
                nodes_links.nodes.forEach(function (n) {
                  idToNode[n.id] = n;
                });
                ES_arc = (d) => {
                  if (d.source == 2 && d.target == 9) {
                    let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                    let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                    return [
                      "M",
                      start,
                      nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                      "A", // This means we're gonna build an elliptical arc
                      (start - end) / 2, // major axis
                      (start - end) / 6, //minor axis
                      0,
                      0,
                      start < end ? 0 : 1, // arc lower
                      end,
                      nodesHeight + rectHeight / 2,
                    ].join(" ");
                  } else {
                    let start = xScale(idToNode[d.source].coordinate);
                    let end = xScale(idToNode[d.target].coordinate);
                    return [
                      "M",
                      start,
                      nodesHeight + rectHeight / 2,
                      "A",
                      (start - end) / 2, // major axis
                      (start - end) / 6, //minor axis
                      0,
                      0,
                      start < end ? 1 : 0, // arc upper
                      end,
                      nodesHeight + rectHeight / 2,
                    ].join(" ");
                  }
                };
              }
              // Plot AS model when init
              // console.log(d3.select('g.as-model')._groups[0][0] == null);
              // console.log(d3.select('g.as-model'));
              if (d3.select("g.as-model")._groups[0][0] == null) {
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              } else {
                d3.select("g.as-model").remove();
                d3.select("g.introns-as-model").remove();
                d3.select("g.as-model-extent").remove();
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              }
              // Plot Nodes and Links for AS Event
              // console.log(d3.select('g.as-model path')._groups[0][0] == null);
              if (d3.select("g.as-model path")._groups[0][0] == null) {
                plotNodesAndLinks(as_type, nodes_links, ES_arc);
              } else {
                updateNodesAndLinks(as_type, nodes_links, ES_arc);
              }
              // Add brush for context
              // addBrush(nodes_links, ES_arc);
            }
            // alternative 3’ splice site (A3SS)
            if (as_type == "A3SS") {
              let arr = event_coords
                .split(":")
                .map((d) => +d)
                .sort((a, b) => a - b); // sort coordinates
              // console.log(arr);
              let flankingES,
                flankingEE,
                longES,
                longEE,
                shortES,
                shortEE,
                as_model_exons,
                as_model_introns;
              if (strand == "+") {
                flankingES = arr[0];
                flankingEE = arr[1];
                longES = arr[2];
                shortES = arr[3];
                longEE = arr[4];
                shortEE = arr[5];
                as_model_exons = [
                  {
                    start: flankingES,
                    end: flankingEE,
                    length: flankingEE - flankingES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: longES,
                    end: longEE,
                    length: longEE - longES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: shortES,
                    end: shortEE,
                    length: shortEE - shortES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: flankingEE, end: longES, name: "AS Model" },
                ];
              } else {
                flankingES = arr[5];
                flankingEE = arr[4];
                longES = arr[3];
                shortES = arr[2];
                longEE = arr[1];
                shortEE = arr[0];
                as_model_exons = [
                  {
                    start: flankingEE,
                    end: flankingES,
                    length: flankingES - flankingEE + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: longEE,
                    end: longES,
                    length: longES - longEE + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: shortEE,
                    end: shortES,
                    length: shortES - shortEE + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: longES, end: flankingEE, name: "AS Model" },
                ];
              }

              let nodes_links = {
                nodes: [
                  {
                    id: 1,
                    coordinate: flankingES,
                  },
                  {
                    id: 2,
                    coordinate: flankingEE,
                  },
                  {
                    id: 3,
                    coordinate: longES,
                  },
                  {
                    id: 4,
                    coordinate: shortES,
                  },
                  {
                    id: 5,
                    coordinate: longEE,
                  },
                  {
                    id: 6,
                    coordinate: shortEE,
                  },
                ],
                links: [
                  {
                    source: 2,
                    target: 3,
                  },
                  {
                    source: 2,
                    target: 4,
                  },
                ],
              };
              const allNodes = nodes_links.nodes.map((d) => d.coordinate);
              // console.log(allNodes);
              const idToNode = {};
              nodes_links.nodes.forEach(function (n) {
                idToNode[n.id] = n;
              });
              let A3SS_arc = (d) => {
                if (d.source == 2 && d.target == 4) {
                  let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                  let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                    "A", // This means we're gonna build an elliptical arc
                    (start - end) / 2, // major axis
                    (start - end) / 6, //minor axis
                    0,
                    0,
                    start < end ? 0 : 1, // arc lower
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                } else {
                  let start = xScale(idToNode[d.source].coordinate);
                  let end = xScale(idToNode[d.target].coordinate);
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2,
                    "A",
                    (start - end) / 2, // major axis
                    (start - end) / 6, //minor axis
                    0,
                    0,
                    start < end ? 1 : 0, // arc upper
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                }
              };
              // Plot AS model when init
              // console.log(d3.select('g.as-model')._groups[0][0] == null);
              if (d3.select("g.as-model")._groups[0][0] == null) {
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              } else {
                d3.select("g.as-model").remove();
                d3.select("g.introns-as-model").remove();
                d3.select("g.as-model-extent").remove();
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              }
              // Plot Nodes and Links for AS Event
              // console.log(d3.select('g.as-model path')._groups[0][0] == null);
              if (d3.select("g.as-model path")._groups[0][0] == null) {
                plotNodesAndLinks(as_type, nodes_links, A3SS_arc);
              } else {
                updateNodesAndLinks(as_type, nodes_links, A3SS_arc);
              }
              // Add brush for context
              // addBrush(nodes_links, A3SS_arc)
            }
            // alternative 5’ splice site (A5SS)
            if (as_type == "A5SS") {
              let arr = event_coords
                .split(":")
                .map((d) => +d)
                .sort((a, b) => a - b); // sort coordinates
              // console.log(arr);
              let flankingES,
                flankingEE,
                longES,
                longEE,
                shortES,
                shortEE,
                as_model_exons,
                as_model_introns;
              if (strand == "+") {
                longES = arr[0];
                shortES = arr[1];
                shortEE = arr[2];
                longEE = arr[3];
                flankingES = arr[4];
                flankingEE = arr[5];
                as_model_exons = [
                  {
                    start: flankingES,
                    end: flankingEE,
                    length: flankingEE - flankingES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: longES,
                    end: longEE,
                    length: longEE - longES + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: shortES,
                    end: shortEE,
                    length: shortEE - shortES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: longEE, end: flankingES, name: "AS Model" },
                ];
              } else {
                longES = arr[5];
                shortES = arr[4];
                shortEE = arr[3];
                longEE = arr[2];
                flankingES = arr[1];
                flankingEE = arr[0];
                as_model_exons = [
                  {
                    start: flankingEE,
                    end: flankingES,
                    length: flankingES - flankingEE + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: longEE,
                    end: longES,
                    length: longES - longEE + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: shortEE,
                    end: shortES,
                    length: shortES - shortEE + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: longEE, end: flankingES, name: "AS Model" },
                ];
              }
              let nodes_links = {
                nodes: [
                  {
                    id: 1,
                    coordinate: longES,
                  },
                  {
                    id: 2,
                    coordinate: shortES,
                  },
                  {
                    id: 3,
                    coordinate: shortEE,
                  },
                  {
                    id: 4,
                    coordinate: longEE,
                  },
                  {
                    id: 5,
                    coordinate: flankingES,
                  },
                  {
                    id: 6,
                    coordinate: flankingEE,
                  },
                ],
                links: [
                  {
                    source: 3,
                    target: 5,
                  },
                  {
                    source: 4,
                    target: 5,
                  },
                ],
              };
              const allNodes = nodes_links.nodes.map((d) => d.coordinate);
              // console.log(allNodes);
              const idToNode = {};
              nodes_links.nodes.forEach(function (n) {
                idToNode[n.id] = n;
              });
              let A5SS_arc = (d) => {
                if (d.source == 4 && d.target == 5) {
                  let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                  let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                    "A", // This means we're gonna build an elliptical arc
                    (start - end) / 2, // major axis
                    (start - end) / 6, //minor axis
                    0,
                    0,
                    start < end ? 0 : 1, // arc lower
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                } else {
                  let start = xScale(idToNode[d.source].coordinate);
                  let end = xScale(idToNode[d.target].coordinate);
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2,
                    "A",
                    (start - end) / 2, // major axis
                    (start - end) / 6, //minor axis
                    0,
                    0,
                    start < end ? 1 : 0, // arc upper
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                }
              };
              // Plot AS model when init
              // console.log(d3.select('g.as-model')._groups[0][0] == null);
              if (d3.select("g.as-model")._groups[0][0] == null) {
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              } else {
                d3.select("g.as-model").remove();
                d3.select("g.introns-as-model").remove();
                d3.select("g.as-model-extent").remove();
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              }
              // Plot Nodes and Links for AS Event
              // console.log(d3.select('g.as-model path')._groups[0][0] == null);
              if (d3.select("g.as-model path")._groups[0][0] == null) {
                plotNodesAndLinks(as_type, nodes_links, A5SS_arc);
              } else {
                updateNodesAndLinks(as_type, nodes_links, A5SS_arc);
              }
              // Add brush for context
              // addBrush(nodes_links, A5SS_arc)
            }
            // mutually exclusive exons (MEX)
            if (as_type == "MEX") {
              let arr = event_coords
                .split(":")
                .map((d) => +d)
                .sort((a, b) => a - b); // sort coordinates
              // console.log(arr);
              let upstreamES,
                upstreamEE,
                firstExonStart,
                firstExonEnd,
                secnodExonStart,
                secnodExonEnd,
                downstreamES,
                downstreamEE,
                as_model_exons,
                as_model_introns;
              if (strand == "+") {
                upstreamES = arr[0];
                upstreamEE = arr[1];
                firstExonStart = arr[2];
                firstExonEnd = arr[3];
                secnodExonStart = arr[4];
                secnodExonEnd = arr[5];
                downstreamES = arr[6];
                downstreamEE = arr[7];
                as_model_exons = [
                  {
                    start: upstreamES,
                    end: upstreamEE,
                    length: upstreamEE - upstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: firstExonStart,
                    end: firstExonEnd,
                    length: firstExonEnd - firstExonStart + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: secnodExonStart,
                    end: secnodExonEnd,
                    length: secnodExonEnd - secnodExonStart + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: downstreamES,
                    end: downstreamEE,
                    length: downstreamEE - downstreamES + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: upstreamEE, end: firstExonStart, name: "AS Model" },
                  {
                    start: firstExonEnd,
                    end: secnodExonStart,
                    name: "AS Model",
                  },
                  { start: secnodExonEnd, end: downstreamES, name: "AS Model" },
                ];
              } else {
                upstreamES = arr[7];
                upstreamEE = arr[6];
                firstExonStart = arr[5];
                firstExonEnd = arr[4];
                secnodExonStart = arr[3];
                secnodExonEnd = arr[2];
                downstreamES = arr[1];
                downstreamEE = arr[0];
                as_model_exons = [
                  {
                    start: upstreamEE,
                    end: upstreamES,
                    length: upstreamES - upstreamEE + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                  {
                    start: firstExonEnd,
                    end: firstExonStart,
                    length: firstExonStart - firstExonEnd + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: secnodExonEnd,
                    end: secnodExonStart,
                    length: secnodExonStart - secnodExonEnd + 1,
                    name: "AS Model",
                    color: asColor,
                  },
                  {
                    start: downstreamEE,
                    end: downstreamES,
                    length: downstreamES - downstreamEE + 1,
                    name: "AS Model",
                    color: exonColor,
                  },
                ];
                as_model_introns = [
                  { start: firstExonStart, end: upstreamEE, name: "AS Model" },
                  {
                    start: secnodExonStart,
                    end: firstExonEnd,
                    name: "AS Model",
                  },
                  { start: downstreamES, end: secnodExonEnd, name: "AS Model" },
                ];
              }

              let nodes_links = {
                nodes: [
                  {
                    id: 1,
                    coordinate: upstreamES,
                  },
                  {
                    id: 2,
                    coordinate: upstreamEE,
                  },
                  {
                    id: 3,
                    coordinate: firstExonStart,
                  },
                  {
                    id: 4,
                    coordinate: firstExonEnd,
                  },
                  {
                    id: 5,
                    coordinate: secnodExonStart,
                  },
                  {
                    id: 6,
                    coordinate: secnodExonEnd,
                  },
                  {
                    id: 7,
                    coordinate: downstreamES,
                  },
                  {
                    id: 8,
                    coordinate: downstreamEE,
                  },
                ],
                links: [
                  {
                    source: 2,
                    target: 3,
                  },
                  {
                    source: 4,
                    target: 7,
                  },
                  {
                    source: 2,
                    target: 5,
                  },
                  {
                    source: 6,
                    target: 7,
                  },
                ],
              };
              const allNodes = nodes_links.nodes.map((d) => d.coordinate);
              // console.log(allNodes);
              const idToNode = {};
              nodes_links.nodes.forEach(function (n) {
                idToNode[n.id] = n;
              });
              let MEX_arc = (d) => {
                if (
                  (d.source == 2 && d.target == 5) ||
                  (d.source == 6 && d.target == 7)
                ) {
                  let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                  let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                    "A", // This means we're gonna build an elliptical arc
                    (start - end) / 2, // major axis
                    (start - end) / 10, //minor axis
                    0,
                    0,
                    start < end ? 0 : 1, // arc lower
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                } else {
                  let start = xScale(idToNode[d.source].coordinate);
                  let end = xScale(idToNode[d.target].coordinate);
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2,
                    "A",
                    (start - end) / 2, // major axis
                    (start - end) / 10, //minor axis
                    0,
                    0,
                    start < end ? 1 : 0, // arc upper
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                }
              };
              // Plot AS model when init
              // console.log(d3.select('g.as-model')._groups[0][0] == null);
              if (d3.select("g.as-model")._groups[0][0] == null) {
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              } else {
                d3.select("g.as-model").remove();
                d3.select("g.introns-as-model").remove();
                d3.select("g.as-model-extent").remove();
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              }
              // Plot Nodes and Links for AS Event
              // console.log(d3.select('g.as-model path')._groups[0][0] == null);
              if (d3.select("g.as-model path")._groups[0][0] == null) {
                plotNodesAndLinks(as_type, nodes_links, MEX_arc);
              } else {
                updateNodesAndLinks(as_type, nodes_links, MEX_arc);
              }
              // Add brush for context
              // addBrush(nodes_links, MEX_arc)
            }
            // intron retained (IR)
            if (as_type == "IR") {
              let arr = event_coords
                .split(":")
                .map((d) => +d)
                .sort((a, b) => a - b); // sort coordinates
              // console.log(arr);
              let upstreamES = arr[0];
              let upstreamEE = arr[1];
              let downstreamES = arr[2];
              let downstreamEE = arr[3];
              let as_model_exons = [
                {
                  start: upstreamES,
                  end: upstreamEE,
                  length: upstreamEE - upstreamES + 1,
                  name: "AS Model",
                  color: asColor,
                },
                {
                  start: downstreamES,
                  end: downstreamEE,
                  length: downstreamEE - downstreamES + 1,
                  name: "AS Model",
                  color: asColor,
                },
              ];
              let as_model_introns = [
                { start: upstreamEE, end: downstreamES, name: "AS Model" },
              ];
              let nodes_links = {
                nodes: [
                  {
                    id: 1,
                    coordinate: upstreamES,
                  },
                  {
                    id: 2,
                    coordinate: upstreamEE,
                  },
                  {
                    id: 3,
                    coordinate: downstreamES,
                  },
                  {
                    id: 4,
                    coordinate: downstreamEE,
                  },
                ],
                links: [
                  // {
                  //   "source": 1,
                  //   "target": 2
                  // },
                  // {
                  //   "source": 3,
                  //   "target": 4
                  // },
                  {
                    source: 2,
                    target: 3,
                  },
                ],
              };
              const allNodes = nodes_links.nodes.map((d) => d.coordinate);
              // console.log(allNodes);
              const idToNode = {};
              nodes_links.nodes.forEach(function (n) {
                idToNode[n.id] = n;
              });
              let IR_arc = (d) => {
                if (d.source == 2 && d.target == 3) {
                  let start = xScale(idToNode[d.source].coordinate); // X position of start node on the X axis
                  let end = xScale(idToNode[d.target].coordinate); // X position of end node on the X axis
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2, // the arc starts at the coordinate x=start, y=40 (where the starting node is)
                    "A", // This means we're gonna build an elliptical arc
                    (start - end) / 2, // major axis
                    (start - end) / 4, //minor axis
                    0,
                    0,
                    start < end ? 0 : 1, // arc lower
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                } else {
                  let start = xScale(idToNode[d.source].coordinate);
                  let end = xScale(idToNode[d.target].coordinate);
                  return [
                    "M",
                    start,
                    nodesHeight + rectHeight / 2,
                    "A",
                    (start - end) / 2, // major axis
                    (start - end) / 6, //minor axis
                    0,
                    0,
                    start < end ? 1 : 0, // arc upper
                    end,
                    nodesHeight + rectHeight / 2,
                  ].join(" ");
                }
              };
              // Plot AS model when init
              // console.log(d3.select('g.as-model')._groups[0][0] == null);
              if (d3.select("g.as-model")._groups[0][0] == null) {
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              } else {
                d3.select("g.as-model").remove();
                d3.select("g.introns-as-model").remove();
                d3.select("g.as-model-extent").remove();
                plotASModel(as_model_exons, as_model_introns);
                plotASModelExtent(event_coords);
              }
              // Plot Nodes and Links for AS Event
              // console.log(d3.select('g.as-model path')._groups[0][0] == null);
              if (d3.select("g.as-model path")._groups[0][0] == null) {
                plotNodesAndLinks(as_type, nodes_links, IR_arc);
              } else {
                updateNodesAndLinks(as_type, nodes_links, IR_arc);
              }
              // Add brush for context
              // addBrush(nodes_links, IR_arc)
            }
          }
        }
        plotASEvents(as_type, event_coords);

        // paint the legend
        // svg.append('g')
        //   .attr("class", "legend-background")
        //   .append("rect")
        //   .attr('x', margin.left + 85)
        //   .attr('y', height - margin.bottom + 8)
        //   .attr('width', 135)
        //   .attr('height', 10)
        //   .attr('rx', 1) // set border-radius
        //   .attr('stroke', 'rgb(0,0,0)') // set border color
        //   .attr('stroke-dasharray', '1,1')
        //   .attr('stroke-width', 0.3) // set border width
        //   .attr('fill', '#F5F5F5')
        // // paint the legend-exon
        // svg.append('g')
        //   .attr("class", "legend-exon")
        //   .append("rect")
        //   .attr('x', margin.left + 90)
        //   .attr('y', height - margin.bottom + 10)
        //   .attr('width', 10)
        //   .attr('height', 6)
        //   .attr('rx', 1)
        //   .attr('stroke', 'rgb(0,0,0)')
        //   .attr('stroke-width', 0.3)
        //   .attr('fill', exonColor)
        // // paint the legend-exon-text
        // svg.append('g')
        //   .attr("class", "legend-exon-text")
        //   .append("text")
        //   .attr("x", margin.left + 90 + 15)
        //   .attr("y", height - margin.bottom + 14)
        //   .text("Exon")
        //   .attr('font-size', 4)
        //   .style("font-family", "Arial");
        // // paint the legend-utr
        // svg.append('g')
        //   .attr("class", "legend-utr")
        //   .append("rect")
        //   .attr('x', margin.left + 105 + 20)
        //   .attr('y', height - margin.bottom + 11)
        //   .attr('width', 10)
        //   .attr('height', 4)
        //   .attr('rx', 0.5)
        //   .attr('stroke', 'rgb(0,0,0)')
        //   .attr('stroke-width', 0.3)
        //   .attr('fill', utrColor)
        // // paint the legend-utr-text
        // svg.append('g')
        //   .attr("class", "legend-utr-text")
        //   .append("text")
        //   .attr("x", margin.left + 125 + 15)
        //   .attr("y", height - margin.bottom + 14)
        //   .text("UTR")
        //   .attr('font-size', 4)
        //   .style("font-family", "Arial");
        // // paint the legend-codon
        // svg.append('g')
        //   .attr("class", "legend-codon")
        //   .append("circle")
        //   .attr('cx', margin.left + 140 + 20)
        //   .attr('cy', height - margin.bottom + 13)
        //   .attr('r', 1)
        //   .attr("fill", "red")
        //   .attr("stroke", "black")
        //   .attr("stroke-width", "0.3")
        // // paint the legend-codon-text
        // svg.append('g')
        //   .attr("class", "legend-codon-text")
        //   .append("text")
        //   .attr("x", margin.left + 160 + 6)
        //   .attr("y", height - margin.bottom + 14)
        //   .text("Codon")
        //   .attr('font-size', 4)
        //   .style("font-family", "Arial");
        // // paint the legend-intron
        // svg.append('g')
        //   .attr("class", "legend-intron")
        //   .append("line")
        //   .attr('x1', margin.left + 166 + 20)
        //   .attr('y1', height - margin.bottom + 13)
        //   .attr('x2', margin.left + 166 + 30)
        //   .attr('y2', height - margin.bottom + 13)
        //   .attr("stroke", "grey")
        //   .attr("stroke-width", "0.5px")
        // // paint the legend-intron-text
        // svg.append('g')
        //   .attr("class", "legend-intron-text")
        //   .append("text")
        //   .attr("x", margin.left + 196 + 5)
        //   .attr("y", height - margin.bottom + 14)
        //   .text("Intron")
        //   .attr('font-size', 4)
        //   .style("font-family", "Arial");

        // paint arrow
        svg
          .append("g")
          .append("marker")
          .attr("id", "arrow")
          .attr("markerUnits", "strokeWidth") //设置为strokeWidth箭头会随着线的粗细发生变化
          .attr("viewBox", "0 0 10 10") //坐标系的区域
          .attr("refX", 6) //箭头坐标
          .attr("refY", 6)
          .attr("markerWidth", 12)
          .attr("markerHeight", 12)
          // .attr("orient", "auto") //绘制方向，可设定为：auto（自动确认方向）和 角度值
          .attr("orient", "auto-start-reverse") //绘制方向，可设定为：auto-start-reverse 和 角度值
          .append("path")
          .attr("d", "M2,2 L10,6 L2,10 L6,6 L2,2") //箭头的路径
          .attr("fill", "black") //箭头颜色
          .attr("opacity", 0.5);

        // 绘制与箭头相连的直线
        let arrowline = svg
          .append("g")
          .append("line")
          .attr("x1", margin.left)
          .attr("y1", height - margin.bottom + 10)
          .attr("x2", width - margin.right)
          .attr("y2", height - margin.bottom + 10)
          .attr("fill", "none")
          .attr("stroke", "black")
          .attr("stroke-width", 0.5)
          .attr("stroke-opacity", 0.5)
          .attr("stroke-dasharray", (6, 5));
        // .attr("marker-start", "url(#arrow)");

        // 根据正负链判断箭头方向，并在箭头上方添加文字
        // console.log(strand);
        if (strand == "+") {
          arrowline.attr("marker-end", "url(#arrow)");
          svg
            .append("g")
            .append("text")
            .attr("x", margin.left)
            .attr("y", height - margin.bottom + 15)
            .text("5'")
            .attr("font-size", 6)
            .attr("opacity", 0.8);
          svg
            .append("g")
            .append("text")
            .attr("x", width - margin.right - 7)
            .attr("y", height - margin.bottom + 15)
            .text("3'")
            .attr("font-size", 6)
            .attr("opacity", 0.8);
        } else {
          arrowline.attr("marker-start", "url(#arrow)");
          svg
            .append("g")
            .append("text")
            .attr("x", margin.left)
            .attr("y", height - margin.bottom + 15)
            .text("3'")
            .attr("font-size", 6)
            .attr("opacity", 0.8);
          svg
            .append("g")
            .append("text")
            .attr("x", width - margin.right - 7)
            .attr("y", height - margin.bottom + 15)
            .text("5'")
            .attr("font-size", 6)
            .attr("opacity", 0.8);
        }

        // zoom
        function zoomed(event) {
          xScale.range(
            [margin.left, width - margin.right].map((d) =>
              event.transform.applyX(d)
            )
          );
          // console.log([margin.left, width - margin.right].map(d => event.transform.applyX(d)));

          // zoom in/out Transcripts
          svg.select(".x-axis").call(xAxis);
          svg
            .selectAll(".exons rect")
            .attr("x", (d) => xScale(d.start))
            .attr("width", (d) => xScale(d.end) - xScale(d.start));
          svg
            .selectAll(".introns line")
            .attr("x1", (d) => xScale(d.start))
            .attr("x2", (d) => xScale(d.end));
          svg
            .selectAll(".utrs rect")
            .attr("x", (d) => xScale(d.start))
            .attr("width", (d) => xScale(d.end) - xScale(d.start));
          svg
            .selectAll(".start-codons circle")
            .attr("cx", (d) => xScale(d.start + 1));
          svg
            .selectAll(".stop-codons circle")
            .attr("cx", (d) => xScale(d.start + 1));

          // zoom in/out AS Model
          svg
            .selectAll(".exons-as-model rect")
            .attr("x", (d) => xScale(d.start))
            .attr("width", (d) => xScale(d.end) - xScale(d.start));
          svg
            .selectAll(".introns-as-model line")
            .attr("x1", (d) => xScale(d.start))
            .attr("x2", (d) => xScale(d.end));
          plotASEvents(as_type, event_coords);
          // sliderRange.default([start + 1000, end - 1000])
          // svg.select("g.slider line.track-fill").attr('x1', "60").attr('x2', "150");

          // zoom in/out AS Model extent
          svg
            .selectAll(".as-model-extent rect")
            .attr("x", (d) => xScale(d.start))
            .attr("width", (d) => xScale(d.end) - xScale(d.start));
        }
        let extent = [
          [margin.left, margin.top],
          [width - margin.right, height - margin.top],
        ];
        let zoom = d3
          .zoom()
          .scaleExtent([1, 20]) // set the range of zoom in and out
          .translateExtent(extent)
          .extent(extent)
          .on("zoom", zoomed);
        svg.call(zoom).on("wheel.zoom", null); // disable zoom on scrollwheel

        // eventFocus
        function eventFocus() {
          let event_coordinates = event_coords;
          let arr = event_coords && event_coords.split(":");
          // console.log(event_coordinates);
          if (event_coordinates !== ("NA" || "-" || "")) {
            let event_start = arr[0];
            let event_end = arr[arr.length - 1];
            let x1 = xScale(event_start);
            let x2 = xScale(event_end);
            let distance = x2 - x1;
            // console.log(event_start);
            // console.log(event_end);
            // console.log(x1);
            // console.log(x2);
            // console.log(distance);

            // [margin.left, width - margin.right] : [45, 370]
            // set scale based on the distance between event_start and event_end
            if (0 < distance <= 100) {
              svg
                .transition()
                .duration(1500)
                .call(
                  zoom.transform,
                  d3.zoomIdentity
                    .translate(margin.left + 10, 0)
                    .scale(4)
                    .translate(-x1, 0)
                );
            }
            if (100 < distance <= 200) {
              svg
                .transition()
                .duration(1500)
                .call(
                  zoom.transform,
                  d3.zoomIdentity
                    .translate(margin.left + 10, 0)
                    .scale(1.5)
                    .translate(-x1, 0)
                );
            }
            if (200 < distance <= 290) {
              svg
                .transition()
                .duration(1500)
                .call(
                  zoom.transform,
                  d3.zoomIdentity
                    .translate(margin.left + 10, 0)
                    .scale(1.2)
                    .translate(-x1, 0)
                );
            }
            if (distance > 290) {
              svg
                .transition()
                .duration(1500)
                .call(zoom.transform, d3.zoomIdentity.scale(1));
            }
          }
        }
        function zoomIn() {
          // console.log('click zoom in');
          svg.transition().duration(400).call(zoom.scaleBy, 1.2);
        }

        function zoomOut() {
          // console.log('click zoom out');
          svg
            .transition()
            .duration(400)
            .call(zoom.scaleBy, 1 / 1.2);
        }

        function reSet() {
          // console.log('click reset');
          svg
            .transition()
            .duration(750)
            .call(
              zoom.transform,
              d3.zoomIdentity,
              d3.zoomTransform(svg.node()).invert([width / 2, height / 2])
            );
        }

        // Update Transcripts when moving slider
        // function updateTranscriptStructure(values) {
        //   // console.log(values);
        //   xScale.domain(values); // change the X-axis domain
        //   svg.select(".x-axis").call(xAxis).call(g => g.selectAll(".domain").attr("stroke-width", "0.3")) // x 轴
        //     .call(g => g.selectAll(".tick line").attr("stroke-width", "0.3")) // x 轴 刻度线
        //     .call(g => g.selectAll(".tick text").attr("font-size", "4.5").attr("font-family", "Arial")) // x 轴 刻度文字;

        //   svg.selectAll(".exons rect").attr('x', d => xScale(d.start)).attr('y', d => yScale(d.tx_id))
        //     .attr('width', d => xScale(d.end) - xScale(d.start));
        //   svg.selectAll(".introns line").attr("x1", d => xScale(d.start)).attr("x2", d => xScale(d.end));
        //   svg.selectAll(".utrs rect").attr('x', d => xScale(d.start)).attr('y', d => yScale(d.tx_id))
        //     .attr('width', d => xScale(d.end) - xScale(d.start));
        //   svg.selectAll(".start-codons circle").attr("cx", d => xScale(d.start + 1))
        //   svg.selectAll(".stop-codons circle").attr("cx", d => xScale(d.start + 1))

        //   // Update AS Model when moving slider
        //   svg.selectAll(".exons-as-model rect").attr('x', d => xScale(d.start))
        //     .attr('width', d => xScale(d.end) - xScale(d.start));
        //   svg.selectAll(".introns-as-model line").attr("x1", d => xScale(d.start)).attr("x2", d => xScale(d.end));
        //   plotASEvents(as_type, event_coords)

        //   // Update AS Model extent when moving slider
        //   svg.selectAll(".as-model-extent rect").attr('x', d => xScale(d.start))
        //     .attr('width', d => xScale(d.end) - xScale(d.start));
        // }
      }
      showTranscriptStructure();

      ////////////////////// Show Protein Structure //////////////////////////
      // request data (getExonToProteinByTxID, getDomainByTxID, getSequenceByTxID)
      let exon_to_protein = [],
        domains = [],
        protein_start = 1,
        all_protein_end = [],
        protein_end,
        tx_id_coding = [];
      // all_tx_ids: e.g. ['ENST00000395080', 'ENST00000237623', 'ENST00000360804']
      if (all_tx_ids.length > 0) {
        // console.log(all_tx_ids.join(','));
        let txid = all_tx_ids.join(",");

        // get the mapping relationship between exons and protein
        await getExonToProteinByTxID(txid)
          .then((data) => {
            // console.log(data);
            data.map((d) => {
              if (d.exon_to_protein) {
                exon_to_protein.push(...d.exon_to_protein); // concat array
                tx_id_coding.push(d.tx_id); // tx_id_coding which is protein-coding
              }
            });
            // console.log(exon_to_protein);
            exon_to_protein.map((d) => all_protein_end.push(d.protein_end)); // extract all protein_end
            protein_end = d3.max(all_protein_end); // gene_select the max protein_end
            // console.log(protein_end);
          })
          .catch((err) => {
            console.error(err);
          });

        // get the protein domains based on ensembl transcript id
        await getDomainByTxID(txid)
          .then((data) => {
            // console.log(data);
            if (data.length > 0) {
              data.map(
                (d) =>
                  d.domain &&
                  d.domain.forEach((v, i, a) => {
                    // v.tx = tx_ids[v.tx_id];
                    v.id = v.tx_id + "_" + i; // add unique identifier 'id'
                  })
              ); // add tx name to every domain item
              data.map((d) => domains.push(...d.domain)); // concat array
              // console.log(domains);

              // this.filteredTranscript && this.filteredTranscript.forEach((v1, i1, a1) => {
              //   data.forEach((v2, i2, a2) => {
              //     if (v1.transcript_id.split('.')[0] == v2.tx_id) {
              //       // v1.uniprot = v2.uniprot
              //       this.$set(v1, "uniprot", v2.uniprot) // this.$set: add uniprot property to filteredTranscript object
              //     }
              //   })
              // })
              // console.log(this.filteredTranscript);
            }
          })
          .catch((err) => {
            console.error(err);
          });

        // get the protein and exons sequence based on ensembl transcript id
        await getSequenceByTxID(txid)
          .then((data) => {
            data &&
              data.forEach((v1, i1, a1) => {
                exon_to_protein.forEach((v2, i2, a2) => {
                  // add protein sequence to exon_to_protein
                  if (v1.protein_id == v2.protein_id) {
                    v2.protein_sequence = v1.protein_sequence.slice(
                      v2.protein_start - 1,
                      v2.protein_end - 1
                    );
                  }
                  // add exon sequence to exon_to_protein
                  v1.exons.forEach((v3, i3, a3) => {
                    if (v3.exon_id == v2.exon_id) {
                      v2.exon_sequence = v3.exon_sequence;
                    }
                  });
                });
              });
            // console.log(data);
            // console.log(exon_to_protein);
          })
          .catch((err) => {
            console.error(err);
          });
      }

      function showProteinStructure() {
        let svg = d3
          .select("div#allProtein > svg")
          .attr("viewBox", [0, 0, width, height])
          .on("click", reSet);

        const zoomin = d3.select("div#allProtein .zoomin");
        zoomin.on("click", zoomIn);
        const zoomout = d3.select("div#allProtein .zoomout");
        zoomout.on("click", zoomOut);
        const reset = d3.select("div#allProtein .reset");
        reset.on("click", reSet);

        // 补齐 exon_to_protein, 使其对应于 all_tx_ids
        // console.log(all_tx_ids);
        // console.log(tx_id_coding);
        if (all_tx_ids.length > 0) {
          all_tx_ids.forEach((v, i, a) => {
            let nc = {};
            if (!tx_id_coding.includes(v)) {
              nc.tx_id = v;
              // nc.protein_id = tx_pro_map[v];
              // nc.protein_start = "";
              // nc.protein_end = "";
              // nc.protein_width = "";
              // nc.cds_ok = "";
              // nc.protein_start = "";
              exon_to_protein.push(nc);
            }
          });
        }
        // sort exon_to_protein based on tx_id, in order to sort the y-axis transcript_name
        exon_to_protein.sort(compare);
        // console.log(exon_to_protein.sort(compare));

        // add X-protein axis
        let xScale_protein = d3
          .scaleLinear()
          .domain([protein_start, protein_end])
          .range([margin.left, width - margin.right]);

        let xAxis_protein = d3
          .axisBottom(xScale_protein)
          .ticks(5)
          .tickSize(2)
          .tickPadding(1)
          .tickFormat((x) => x);
        svg
          .append("g")
          .attr("class", "x-axis-protein")
          .attr("transform", `translate(0,${height - margin.bottom})`)
          .call(xAxis_protein)
          .call((g) => g.selectAll(".domain").attr("stroke-width", "0.3")) // x 轴
          .call((g) => g.selectAll(".tick line").attr("stroke-width", "0.3")) // x 轴 刻度线
          .call((g) =>
            g
              .selectAll(".tick text")
              .attr("font-size", "4.5")
              .attr("font-family", "Arial")
          ) // x 轴 刻度文字
          .attr("clip-path", "url(#clipRect)");

        // slider
        // const sliderRange = sliderBottom(xScale_protein).ticks(0).tickPadding(-18)
        //   .tickFormat(d3.format(',.0f')).default([protein_start, protein_end])
        //   .handle(d3.symbol()
        //     .type(d3.symbolCircle)
        //     .size(10))
        //   .fill("#206595")
        //   .on('onchange', val => {
        //     // console.log(val);
        //     updateProteinStructure(val);
        //   });
        // svg.append('g')
        //   .attr('transform', `translate(0, ${height - margin.bottom + 15})`)
        //   .call(sliderRange)

        // change the slider style
        // d3.selectAll('g.parameter-value > text').attr("font-size", "4.5").attr("font-family", "Arial");
        // d3.selectAll('g.slider > line.track').attr("x1", margin.left).attr("x2", width - margin.right);
        // d3.selectAll('g.slider > line.track-inset').attr("x1", margin.left).attr("x2", width - margin.right);
        // d3.selectAll('g.slider > line.track-overlay').attr("x1", margin.left).attr("x2", width - margin.right).attr("stroke-width", "20"); // default stroke-width=40

        // add Y-protein axis
        let yScale_protein = d3
          .scaleBand()
          .domain(
            exon_to_protein.map(function (d) {
              return d.tx_id;
            })
          )
          .range([height - margin.bottom, asModelHeight])
          .padding(1);
        let yAxis_protein = d3
          .axisLeft(yScale_protein)
          .tickFormat((x) => tx_pro_map[x]); // replace tx_id as protein_id
        svg
          .append("g")
          .attr("class", "y-axis-protein")
          .attr("transform", `translate(${margin.left},${rectHeight / 2})`)
          .call(yAxis_protein)
          .call((g) => g.select(".domain").remove())
          .call((g) => g.selectAll(".tick line").remove())
          .call((g) =>
            g
              .selectAll(".tick text")
              .attr("font-size", "4.5")
              .attr("font-family", "Arial")
              .attr("font-weight", "bold")
          );

        // add exon rects (mapping exons to protein)
        svg
          .append("g")
          .attr("class", "exon-to-protein")
          .selectAll()
          .data(exon_to_protein)
          .join("rect")
          .attr("x", (d) => {
            if (d.protein_start) {
              return xScale_protein(d.protein_start);
            } else {
              return 0;
            }
          })
          .attr("y", (d) => yScale_protein(d.tx_id))
          .attr("width", (d) => {
            if (d.protein_start) {
              return (
                xScale_protein(d.protein_end) - xScale_protein(d.protein_start)
              );
            } else {
              return 0;
            }
          })
          .attr("height", rectHeight)
          .attr("rx", 1) // set border-radius
          .attr("stroke", "rgb(0,0,0)") // set border color
          .attr("stroke-width", 0.3) // set border width
          // .attr('fill', exonColor)
          .attr("fill", exonColor)
          .style("cursor", "pointer")
          .attr("clip-path", "url(#clipRect)")
          .on("mouseover", function () {
            d3.select(this).transition().attr("fill", hoverColor);
          })
          .on("mouseout", function () {
            d3.select(this).transition().attr("fill", exonColor);
          })
          .on("dblclick", function (event, d) {
            // event 不能省略
            // console.log('https://exbio.wzw.tum.de/digger/ID/exon/' + d.exon_id);
            window.open("https://exbio.wzw.tum.de/digger/ID/exon/" + d.exon_id);
          });
        // add tooltips using Tippy.js (mouseenter or focus)
        let exon_protein_rect = d3.selectAll(".exon-to-protein rect");
        exon_protein_rect.attr("data-tippy-content", (d, i) => {
          return `<div>Transcript ID: ${d.tx_id}</div>
            <br>
            <hr style="border: 1px dashed; width: 100%; height: 1px;">
            <br>
            <div>Exon ID: ${d.exon_id}</div>
            <div>Exon Rank: ${d.exon_rank}</div>
            <div>Exon Start: ${d.exon_start}</div>
            <div>Exon End: ${d.exon_end}</div>
            <br>
            <hr style="border: 1px dashed; width: 100%; height: 1px;">
            <br>
            <div>Protein ID: ${d.protein_id}</div>
            <div>Residue Start: ${d.protein_start}</div>
            <div>Residue End: ${d.protein_end}</div>
            <div>Residue Length: ${d.protein_width}</div>`;
        });
        tippy(exon_protein_rect.nodes(), {
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 250,
          delay: 0,
          duration: [0, 0],
        });
        // add tooltips using Tippy.js (click)
        exon_protein_rect.attr("data-tippy-content", (d, i) => {
          return `<div>
          <div>Exon ID: ${d.exon_id}</div>
          <div style="word-wrap:break-word;">Exon Sequence: ${d.exon_sequence}</div>
          <br>
          <hr style="border: 1px dashed; width: 100%; height: 1px;">
          <br>
          <div>Protein ID: ${d.protein_id}</div>
          <div style="word-wrap:break-word;">AA Sequence: ${d.protein_sequence}</div>
          </div>`;
        });
        tippy(exon_protein_rect.nodes(), {
          allowHTML: true,
          trigger: "click",
          placement: "left",
          interactive: true,
          interactiveBorder: 0,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 500,
          delay: 0,
          duration: [0, 0],
        });

        // add domains rect (respect protein domains)
        svg
          .append("g")
          .attr("class", "tx-domain")
          .selectAll()
          .data(domains)
          .join("rect")
          .attr("class", (d) => d.id)
          .attr("x", (d) => xScale_protein(d.pfam_start))
          .attr("y", (d) => yScale_protein(d.tx_id) + 2)
          .attr(
            "width",
            (d) => xScale_protein(d.pfam_end) - xScale_protein(d.pfam_start)
          )
          .attr("height", rectHeight / 2)
          .attr("rx", 1) // set border-radius
          .attr("stroke", "white")
          .attr("fill", domainColor)
          .attr("stroke-width", "0.5")
          .style("cursor", "auto")
          .attr("clip-path", "url(#clipRect)")
          .on("mouseover", function () {
            d3.select(this).transition().attr("fill", hoverColor);
          })
          .on("mouseout", function () {
            d3.select(this).transition().attr("fill", domainColor);
          });
        // add domains tooltips using Tippy.js
        let domain_rect = d3.selectAll(".tx-domain rect");
        domain_rect.attr("data-tippy-content", (d, i) => {
          return `<div>Pfam ID: <a href="http://pfam.xfam.org/family/${d.pfam}" target="_blank">
          <span style="text-decoration:underline; color:#FFFFFF;">${d.pfam}</span>
          </a></div>
             <div>Pfam Start: ${d.pfam_start}</div>
             <div>Pfam End: ${d.pfam_end}</div>`;
        });
        tippy(domain_rect.nodes(), {
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveDebounce: 0,
          appendTo: () => document.body,
          // followCursor: 'horizontal',
          // plugins: [followCursor],
          maxWidth: 200,
          delay: 0,
          duration: [0, 0],
        });

        // add exon number to the exons
        svg
          .append("g")
          .attr("class", "exon-number")
          .selectAll()
          .data(exon_to_protein)
          .join("text")
          .attr("x", (d) => {
            if (d.protein_start) {
              return (
                xScale_protein(d.protein_start) +
                (xScale_protein(d.protein_end) -
                  xScale_protein(d.protein_start)) /
                2 -
                2
              );
            } else {
              return;
            }
          })
          .attr("y", (d) => yScale_protein(d.tx_id) + 5)
          .text((d) => d.exon_rank)
          .attr("fill", "black")
          .attr("font-size", 4)
          .attr("opacity", 1)
          .attr("clip-path", "url(#clipRect)");

        // add location range to the protein domain
        // svg.append('g').attr("class", "domain-start").selectAll().data(domains).join('text')
        //   .attr("x", d => xScale_protein(d.pfam_start)).attr("y", d => yScale_protein(d.tx_id) + 11)
        //   .text(d => d.pfam_start).attr('fill', 'red').attr('font-size', 3).attr('opacity', 1)
        // svg.append('g').attr("class", "domain-end").selectAll().data(domains).join('text')
        //   .attr("x", d => xScale_protein(d.pfam_end) - 3).attr("y", d => yScale_protein(d.tx_id) + 11)
        //   .text(d => d.pfam_end).attr('fill', 'red').attr('font-size', 3).attr('opacity', 1)

        // add pfam name to the protein domain
        // svg.append('g').attr("class", "domain-name")
        //   .selectAll().data(domains).join('text')
        //   .attr("x", d => xScale_protein(d.pfam_start) + (xScale_protein(d.pfam_end) - xScale_protein(d.pfam_start)) / 2 - 8)
        //   .attr("y", d => {
        //     if (yScale_protein(d.tx_id) > 20) {
        //       return yScale_protein(d.tx_id) + 13;
        //     } else {
        //       return yScale_protein(d.tx_id) - 4;
        //     };
        //   })
        //   .text(d => d.pfam).attr('fill', 'red').attr('font-size', 4.5).attr('font-weight', 'bold').attr('opacity', 1)
        //   .attr('clip-path', 'url(#clipRect)')
        //   .on('mouseover', function (event, d1) {
        //     d3.selectAll('.tx-domain rect').filter(d2 => d2.id === d1.id)
        //       .transition().attr('fill', hoverColor).attr("stroke", "black");
        //   })
        //   .on('mouseout', function () {
        //     d3.selectAll('.tx-domain rect').transition().attr('fill', 'none').attr("stroke", "red");
        //   });
        // add domains tooltips using Tippy.js
        // let domain_text = d3.selectAll('.domain-name text');
        // domain_text.attr('data-tippy-content', (d, i) => {
        //   return `<div>Pfam ID: <a href="http://pfam.xfam.org/family/${d.pfam}" target="_blank">
        //   <span style="text-decoration:underline; color:#FFFFFF;">${d.pfam}</span>
        //   </a></div>
        //      <div>Pfam Start: ${d.pfam_start}</div>
        //      <div>Pfam End: ${d.pfam_end}</div>`;
        // });
        // tippy(domain_text.nodes(), {
        //   allowHTML: true,
        //   placement: 'left',
        //   interactive: true,
        //   interactiveDebounce: 0,
        //   appendTo: () => document.body,
        //   // followCursor: 'horizontal',
        //   // plugins: [followCursor],
        //   maxWidth: 200,
        //   delay: 0,
        //   duration: [0, 0],
        // })

        // paint the legend
        // svg.append('g')
        //   .attr("class", "legend-background")
        //   .append("rect")
        //   .attr('x', margin.left + 100)
        //   .attr('y', height - margin.bottom + 9)
        //   .attr('width', 85)
        //   .attr('height', 10)
        //   .attr('rx', 1) // set border-radius
        //   .attr('stroke', 'rgb(0,0,0)') // set border color
        //   .attr('stroke-dasharray', '1,1') // set border color
        //   .attr('stroke-width', 0.3) // set border width
        //   .attr('fill', '#F5F5F5')
        // // paint the legend-exon
        // svg.append('g')
        //   .attr("class", "legend-exon")
        //   .append("rect")
        //   .attr('x', margin.left + 105)
        //   .attr('y', height - margin.bottom + 11)
        //   .attr('width', 10)
        //   .attr('height', 6)
        //   .attr('rx', 1)
        //   .attr('stroke', 'rgb(0,0,0)')
        //   .attr('stroke-width', 0.3)
        //   .attr('fill', exonColor)
        // // paint the legend-exon-text
        // svg.append('g')
        //   .attr("class", "legend-exon-text")
        //   .append("text")
        //   .attr("x", margin.left + 105 + 15)
        //   .attr("y", height - margin.bottom + 15)
        //   .text("Exon")
        //   .attr('font-size', 4)
        //   .style("font-family", "Arial");
        // // paint the legend-domain
        // svg.append('g')
        //   .attr("class", "legend-domain")
        //   .append("rect")
        //   .attr('x', margin.left + 120 + 20)
        //   .attr('y', height - margin.bottom + 10)
        //   .attr('width', 10)
        //   .attr('height', 8)
        //   .attr('rx', 1)
        //   .attr("stroke", "red")
        //   .attr("fill", "none")
        //   .attr("stroke-width", "0.5")
        // // paint the legend-domain-text
        // svg.append('g')
        //   .attr("class", "legend-domain-text")
        //   .append("text")
        //   .attr("x", margin.left + 140 + 15)
        //   .attr("y", height - margin.bottom + 15)
        //   .text("Pfam Domain")
        //   .attr('font-size', 4)
        //   .style("font-family", "Arial");

        function zoomed(event) {
          xScale_protein.range(
            [margin.left, width - margin.right].map((d) =>
              event.transform.applyX(d)
            )
          );
          // console.log([margin.left, width - margin.right].map(d => event.transform.applyX(d)));

          // zoom in/out Proteins
          svg.select(".x-axis-protein").call(xAxis_protein);
          svg
            .selectAll(".exon-to-protein rect")
            .attr("x", (d) => xScale_protein(d.protein_start))
            .attr(
              "width",
              (d) =>
                xScale_protein(d.protein_end) - xScale_protein(d.protein_start)
            );
          svg.selectAll(".exon-number text").attr("x", (d) => {
            if (d.protein_start) {
              return (
                xScale_protein(d.protein_start) +
                (xScale_protein(d.protein_end) -
                  xScale_protein(d.protein_start)) /
                2 -
                1
              );
            } else {
              return;
            }
          });
          svg
            .selectAll(".tx-domain rect")
            .attr("x", (d) => xScale_protein(d.pfam_start))
            .attr(
              "width",
              (d) => xScale_protein(d.pfam_end) - xScale_protein(d.pfam_start)
            );
        }
        let extent = [
          [margin.left, margin.top],
          [width - margin.right, height - margin.top],
        ];
        let zoom = d3
          .zoom()
          .scaleExtent([1, 8]) // set the range of zoom in and out
          .translateExtent(extent)
          .extent(extent)
          .on("zoom", zoomed);
        svg.call(zoom).on("wheel.zoom", null); // disable zoom on scrollwheel

        function zoomIn() {
          // console.log('click zoom in');
          svg.transition().duration(400).call(zoom.scaleBy, 1.2);
        }

        function zoomOut() {
          // console.log('click zoom out');
          svg
            .transition()
            .duration(400)
            .call(zoom.scaleBy, 1 / 1.2);
        }

        function reSet() {
          // console.log('click reset');
          svg
            .transition()
            .duration(750)
            .call(
              zoom.transform,
              d3.zoomIdentity,
              d3.zoomTransform(svg.node()).invert([width / 2, height / 2])
            );
        }
        function updateProteinStructure(values) {
          // console.log(values);
          // Update Priteins when moving slider
          xScale_protein.domain(values); // change the X-axis domain
          svg
            .select(".x-axis-protein")
            .call(xAxis_protein)
            .call((g) => g.selectAll(".domain").attr("stroke-width", "0.3")) // x 轴
            .call((g) => g.selectAll(".tick line").attr("stroke-width", "0.3")) // x 轴 刻度线
            .call((g) =>
              g
                .selectAll(".tick text")
                .attr("font-size", "4.5")
                .attr("font-family", "Arial")
            ); // x 轴 刻度文字;

          // change exon-to-protein rect
          svg
            .selectAll(".exon-to-protein rect")
            .attr("x", (d) => {
              if (d.protein_start) {
                return xScale_protein(d.protein_start);
              } else {
                return 0;
              }
            })
            .attr("y", (d) => yScale_protein(d.tx_id))
            .attr("width", (d) => {
              if (d.protein_start) {
                return (
                  xScale_protein(d.protein_end) -
                  xScale_protein(d.protein_start)
                );
              } else {
                return 0;
              }
            });
          // change exon number
          svg
            .selectAll(".exon-number text")
            .attr("x", (d) => {
              if (d.protein_start) {
                return (
                  xScale_protein(d.protein_start) +
                  (xScale_protein(d.protein_end) -
                    xScale_protein(d.protein_start)) /
                  2 -
                  1
                );
              } else {
                return;
              }
            })
            .attr("y", (d) => yScale_protein(d.tx_id) + 5);
          // change pfam domain rect
          svg
            .selectAll(".tx-domain rect")
            .attr("x", (d) => xScale_protein(d.pfam_start))
            .attr(
              "width",
              (d) => xScale_protein(d.pfam_end) - xScale_protein(d.pfam_start)
            );
          //change pfam domain name
          svg
            .selectAll(".domain-name text")
            .attr(
              "x",
              (d) =>
                xScale_protein(d.pfam_start) +
                (xScale_protein(d.pfam_end) - xScale_protein(d.pfam_start)) /
                2 -
                8
            );
        }
      }
      showProteinStructure();
    },
    showAllTranscript() {
      this.removeStructure();
      let filter_arg = "all";
      this.initStructure(filter_arg);
    },
    showProteinCodingTranscript() {
      this.removeStructure();
      let filter_arg = "protein_coding";
      this.initStructure(filter_arg);
    },
    showSpliceInTranscript() {
      this.removeStructure();
      let filter_arg = "splice_in";
      this.initStructure(filter_arg);
    },
    showSpliceOutTranscript() {
      this.removeStructure();
      let filter_arg = "splice_out";
      this.initStructure(filter_arg);
    },

    async getAllASModelsByGenename() {
      let genename;
      if (this.gene_select) {
        genename = this.gene_select;
      }
      // console.log(genename);
      let promise1 = new Promise((resolve, reject) => {
        getASModelsByGenenamFromKnowledge(genename)
          .then((result) => {
            // console.log(result);
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });

      let promise2 = new Promise((resolve, reject) => {
        getASModelsByGenenameFromDatasets(genename)
          .then((result) => {
            // console.log(result);
            resolve(result);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([promise1, promise2])
        .then((result) => {
          // console.log(result);
          let as_model_items = [];
          let as_models = [];
          result[0] &&
            result[0].forEach((v, i, a) => {
              if (
                v.as_type != "Complex" &&
                as_models.indexOf(v.as_model_id) === -1
              ) {
                as_models.push(v.as_model_id);
                v.flag = ["CASE"];
                as_model_items.push(v);
              }
            });
          // console.log(as_model_items);

          let as_model_items1 = [];
          let as_models1 = [];
          result[1] &&
            result[1].forEach((v, i, a) => {
              if (
                v.as_type != "Complex" &&
                as_models1.indexOf(v.as_model_id) === -1
              ) {
                as_models1.push(v.as_model_id);
                v.flag = ["CPSE"];
                as_model_items1.push(v);
              }
            });
          // console.log(as_model_items1);

          if (as_model_items.length > 0) {
            as_model_items1.forEach((v, i, a) => {
              let index = as_models.indexOf(v.as_model_id);
              // can't find
              if (index === -1) {
                as_model_items.push(v);
              } else {
                // can find
                // console.log(index);
                if (as_model_items[index]["flag"].indexOf("CPSE") === -1) {
                  as_model_items[index]["flag"].push("CPSE");
                }
              }
            });
            as_model_items.forEach((v, i, a) => {
              v.index = i + 1;
            });
            // 基于 as_select 过滤 as_model_items
            if (this.as_select) {
              as_model_items = as_model_items.filter((d) => {
                return d.as_type == this.as_select;
              });
            }
            this.as_model_items = as_model_items;
            this.totalItems_as_model = as_model_items.length;
            this.totalPages_as_model = Math.ceil(
              as_model_items.length / this.pageSize_as_model
            );
          } else {
            as_model_items1.forEach((v, i, a) => {
              v.index = i + 1;
            });
            // 基于 as_select 过滤 as_model_items
            if (this.as_select) {
              as_model_items1 = as_model_items1.filter((d) => {
                return d.as_type == this.as_select;
              });
            }
            this.as_model_items = as_model_items1;
            this.totalItems_as_model = as_model_items1.length;
            this.totalPages_as_model = Math.ceil(
              as_model_items1.length / this.pageSize_as_model
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handlePageChange_as_model(value) {
      this.currentPage_as_model = value;
      this.whichPage_as_model = this.currentPage_as_model;
    },
    handlePageSizeChange_as_model(size) {
      this.pageSize_as_model = size;
      this.currentPage_as_model = 1;
      this.totalPages_as_model = Math.ceil(
        this.as_model_items.length / this.pageSize_as_model
      );
    },
    jumpPage_as_model() {
      // console.log(+this.whichPage);
      if (+this.whichPage_as_model < 1) {
        this.whichPage_as_model = 1;
      }
      if (+this.whichPage_as_model > this.totalPages_as_model) {
        this.whichPage_as_model = this.totalPages_as_model;
      }
      this.currentPage_as_model = +this.whichPage_as_model;
    },
    computeHeight(obj) {
      if (Object.keys(obj).length > 7) {
        return 250;
      } else {
        return null;
      }
    },
    removeStructure() {
      // 这里不能用 d3.select('svg')，因为把 D3 chart plot 也删了
      // d3.select('svg')
      //   .selectAll('*')
      //   .remove();
      d3.select("div#allIsoform > svg").selectAll("*").remove();
      d3.select("div#allProtein > svg").selectAll("*").remove();
    },
    changeRoute() {
      this.$router
        .replace({
          path: "/splicevis",
          query: {
            genename: this.gene_select,
            astype: this.as_select,
            coordinate: this.coordinate_select,
          },
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            console.error(err);
          }
        });
    },
    rowClicked(item) {
      // console.log(item);
      if (this.selected_row[0] !== item.as_model_id) {
        this.selected_row = []; // first empty the array
        this.selected_row.push(item.as_model_id);

        this.selected_event = item.event_id; // update the selected event
        // console.log(this.selected_event);

        this.gene_select = item.gene_name;
        this.as_select = item.as_type;
        this.coordinate_select = item.event_coordinates;
        this.changeRoute();

        this.getSpliceKnowledge(); // update the knowledge, filter by as_model_id

        this.removeStructure();
        if (this.as_select == "IR") {
          this.view_select = "all";
        } else {
          this.view_select = "protein_coding";
        }
        this.initStructure(this.view_select);
      }
    },
    refreshASModel() {
      this.isShowFilterASModel = !this.isShowFilterASModel;

      this.coordinate_select = null;
      this.changeRoute();

      this.selected_row = [];
      this.getSpliceKnowledge();
      this.selected_event = "";
    },
    submit() {
      // let genename;
      // if (this.$route.query.genename) {
      //   genename = this.$route.query.genename;
      // }
      // console.log(genename);

      if (this.gene_list.includes(this.gene_select)) {
        // 使用 this.$router.replace() 既可以修改参数，页面也不会刷新
        this.changeRoute();
        this.selected_row = [];

        this.removeStructure();
        if (this.as_select == "IR") {
          this.view_select = "all";
        } else {
          this.view_select = "protein_coding";
        }
        this.initStructure(this.view_select);

        this.getAllASModelsByGenename(); // get all AS Models of gene
        this.getSpliceKnowledge();
      } else if (this.gene_select == null) {
        window.alert("Please enter the gene name.");
      } else {
        window.alert("Sorry, we cant' find this gene.");
      }
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router
        .push({
          path: "/splicevis",
          query: {
            genename: genename,
            astype: astype,
            coordinate: coordinate,
          },
          // NavigationDuplicated: Avoided redundant navigation to current location
          // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            logError(err);
          }
        });
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router
          .push({
            path: "/search",
            query: {
              genename: genename,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      } else if (genename == null || genename == "") {
        window.alert("Sorry, please input the gene name !");
      }
    },
    goToRegulationNetwork(genename) {
      let regulator = genename;
      if (regulator) {
        this.$router
          .push({
            path: "/tools/regnet",
            query: {
              regulator: regulator,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      } else if (regulator == null || regulator == "") {
        window.alert("Sorry, Gene cannot be null.");
      }
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router
          .push({
            path: "/tools/regexp",
            query: {
              genename: genename,
              source: source,
              project: project,
              eventid: eventid,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router
          .push({
            path: "/tools/survival/asevent",
            query: {
              genename: genename,
              source: source,
              project: project,
              eventid: eventid,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router
          .push({
            path: "/tools/stage/asevent",
            query: {
              genename: genename,
              source: source,
              project: project,
              eventid: eventid,
            },
          })
          .catch((err) => {
            if (
              err.name !== "NavigationDuplicated" &&
              !err.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              // But print any other errors to the console
              logError(err);
            }
          });
      }
    },
    goToDetails(eventid, cancername, pubmedid) {
      this.$router
        .push({
          path: "/browse/knowledge/details",
          query: {
            eventid: eventid,
            cancername: cancername,
            pubmedid: pubmedid,
          },
          // NavigationDuplicated: Avoided redundant navigation to current location
          // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
        })
        .catch((err) => {
          if (
            err.name !== "NavigationDuplicated" &&
            !err.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            // But print any other errors to the console
            logError(err);
          }
        });
    },
    isShowPsiPancanBoxplot(data) {
      // console.log(data);
      this.isShowPsiBoxPlot = data;
    },
    isShowExpPancanBoxplot(data) {
      // console.log(data);
      this.isShowExpBoxPlot = data;
    },
    showAll() {
      this.headers_knowledge.map((h) => {
        this.selectedHeader.push(h.text);
      });
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = [
        "Gene Name",
        "Cancer Type",
        "AS Type",
        "ORF",
        "Method",
        "Mechanism",
        "Function",
        "PubMed",
        "Network",
        "Explorer",
        "Survival",
        "Staging",
        "Details",
      ];
    },
    svgToPdfExample(svg, name) {
      const doc = new window.PDFDocument();
      const chunks = [];
      const stream = doc.pipe({
        // writable stream implementation
        write: (chunk) => chunks.push(chunk),
        end: () => {
          const pdfBlob = new Blob(chunks, {
            type: "application/octet-stream",
          });
          var blobUrl = URL.createObjectURL(pdfBlob);
          //window.open(`${blobUrl}?customfilename.pdf`);

          /* custom file name download */
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = blobUrl;
          a.download = name; // <---- 👈 file name
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        },
        // readable streaaam stub iplementation
        on: (event, action) => { },
        once: (...args) => { },
        emit: (...args) => { },
      });

      window.SVGtoPDF(doc, svg, 0, 0, { useCSS: true });
      doc.end();
    },
    downloadTranscript() {
      // console.log('download');
      let svg = d3.select("div#allIsoform > svg")._groups[0][0];
      // console.log(svg);
      let name = this.gene_select + "_Transcript.pdf";
      this.svgToPdfExample(svg, name);
    },
    downloadProtein() {
      // console.log('download');
      let svg = d3.select("div#allProtein > svg")._groups[0][0];
      // console.log(svg);
      let name = this.gene_select + "_Protein.pdf";
      this.svgToPdfExample(svg, name);
    },
  },
};
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-card__title
  line-height: 0.5rem

.selectColor
  color: #2196f3

// .v-sheet.v-card
//   border-radius: 15px

// g.parameter-value > text
//   font-size: 4

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.pagesize-select
  max-width: 6%

.jump-select
  max-width: 6%

// set the width of guide
::v-deep .v-step
  max-width: 600px
  text-align: start

// set the style of highlight
.v-tour__target--highlighted
  border: 1px red solid
  border-radius: 0.8rem
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4)

.guide-btn-style
  position: fixed
  right: 1%
  top: 90%
  transform: translateY(-50%)
  z-index: 99

// Narrow the display columns spaces
.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>